export default {
    zh: {
        // 生成器部分
        generatorTitle: 'Runway Gen-4.5 AI 视频生成器',
        generatorDescription: 'Runway Gen-4.5 是 Runway 公司于2025年12月推出的最新旗舰级AI视频生成模型，代表了生成式视频技术的"新前沿"。作为 Gen-4 系列的重大升级，该模型引入了突破性的"自回归扩散（Autoregressive-to-Diffusion, A2D）"混合架构，彻底解决了以往模型在物理规律模拟和长时序一致性上的痛点。它不仅在 Artificial Analysis 的视频竞技场中以 1247 的 Elo 分数位居榜首，更因其对流体动力学、重力感应及复杂光影的精准还原而成为专业创作者的首选。快来 微鲤AI 免费体验 Runway Gen-4.5，感受超越现实的影像创造力！',
        
        // 标签页
        tabImageToVideo: '图生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Runway Gen-4.5 核心功能',
        coreFeaturesSubtitle: '深入了解 Runway Gen-4.5 视频生成器的物理引擎与混合架构，体验精准可控的电影级创作。',

        // 功能1: 物理规律模拟引擎
        feature1Title: '物理规律模拟引擎',
        feature1Description: 'Gen-4.5 最显著的提升在于对真实世界物理法则的深刻理解。它能准确模拟物体的重量、动量、碰撞以及复杂的流体动力学效果，彻底告别AI视频中常见的"漂浮感"和反直觉运动。',

        // 功能2: 自回归扩散混合架构
        feature2Title: '自回归扩散混合架构',
        feature2Description: '结合了自回归模型的场景理解能力和扩散模型的视觉高保真度。这种混合技术确保了角色和物体在快速运动或遮挡情况下，依然保持结构完整，不会发生形变或消失。',

        // 功能3: 超强提示词依从性
        feature3Title: '超强提示词依从性',
        feature3Description: '模型对复杂提示词的执行力达到了新高度，能够精准还原用户描述的每一个细节，包括构图、光照风格及多主体间的互动关系，"所想即所得"。',

        // 功能4: 微观细节时序一致性
        feature4Title: '微观细节时序一致性',
        feature4Description: '专注于维持微小细节在时间维度上的稳定性。无论是发丝的飘动、水面的波纹还是皮肤的质感，都能在整个视频片段中保持连贯，消除了传统模型常见的"闪烁"现象。',

        // 如何使用部分
        howToUseTitle: '如何在 微鲤AI 上使用',
        step1Title: '登录工作台',
        step1Description: '进入 微鲤AI 创作工作台，在左侧导航栏点击"视频模型"库。',
        step2Title: '选择模型',
        step2Description: '在模型列表中找到并选中 Runway Gen-4.5（标记为 New）。',
        step3Title: '输入描述',
        step3Description: '在文本框中输入您的详细提示词（建议包含动作、光影和物理状态描述），或上传参考图以使用"图生视频"功能。',
        step4Title: '调整设置与生成',
        step4Description: '设置视频比例（如 16:9）和时长（支持 5s 或 10s），点击"立即生成"即可获取高清视频。',

        // YouTube 视频部分
        youtubeTitle: 'YouTube 视频',

        // X 推文部分
        xPostsTitle: 'X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '探索 微鲤AI 上的其他视频模型',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Runway Gen-4.5 是什么？',
        faq1Answer: '它是 Runway 最新发布的旗舰级文生视频模型，以其卓越的物理规律模拟能力和画面稳定性著称，目前在行业基准测试中排名第一。',
        faq2Question: '它和 Gen-4 有什么区别？',
        faq2Answer: 'Gen-4.5 引入了 A2D 混合架构，相比 Gen-4，它在物体运动的物理真实感（如重力、惯性）、画面的时序一致性以及对复杂提示词的理解上有显著提升。',
        faq3Question: '生成视频的时长是多少？',
        faq3Answer: '目前 Gen-4.5 支持生成最高 10 秒的高清视频片段，非常适合制作短视频、广告镜头或电影预演（Previs）。',
        faq4Question: '在 微鲤AI 上使用需要付费吗？',
        faq4Answer: '微鲤AI 为新用户提供免费体验额度。由于 Gen-4.5 算力成本较高，消耗的积分会略多于旧版模型，建议升级 Pro 会员以获取更多生成次数。',
        faq5Question: '它支持"图生视频"吗？',
        faq5Answer: '支持。Gen-4.5 的图生视频功能非常强大，能够完美保留参考图的风格和角色特征，并让其自然地动起来。',
        faq6Question: '适合什么样的项目？',
        faq6Answer: '非常适合追求电影质感的商业广告、视觉特效（VFX）预演、复杂的物理动态展示（如流体、爆炸）以及叙事类短片创作。',

        // CTA 部分
        ctaTitle: '立即体验 Runway Gen-4.5',
        ctaDescription: '在 微鲤AI 上免费试用 Runway Gen-4.5，创造超越想象的AI视频',
        ctaButton: '开始创作',
        ctaDisclaimer: '无需信用卡 · 新用户免费体验',
    },
    en: {
        // Generator section
        generatorTitle: 'Generator Video AI Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 is Runway\'s latest flagship AI video generation model launched in December 2025, representing the "new frontier" of generative video technology. As a major upgrade to the Gen-4 series, this model introduces a breakthrough "Autoregressive-to-Diffusion (A2D)" hybrid architecture that completely solves the pain points of previous models in physical law simulation and long-term temporal consistency. It not only ranks first in Artificial Analysis\'s video arena with an Elo score of 1247, but also becomes the first choice for professional creators due to its precise restoration of fluid dynamics, gravity sensing, and complex lighting. Come to 微鲤AI to experience Runway Gen-4.5 for free and feel the creative power of images beyond reality!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',

        // Core features section
        coreFeaturesTitle: 'Runway Gen-4.5 Core Features',
        coreFeaturesSubtitle: 'Deep dive into Runway Gen-4.5 video generator\'s physics engine and hybrid architecture, experience precise and controllable cinematic creation.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Physics Simulation Engine',
        feature1Description: 'The most significant improvement of Gen-4.5 lies in its deep understanding of real-world physical laws. It can accurately simulate object weight, momentum, collisions, and complex fluid dynamics effects, completely eliminating the common "floating feeling" and counter-intuitive motion in AI videos.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Autoregressive-to-Diffusion Hybrid Architecture',
        feature2Description: 'Combines the scene understanding capability of autoregressive models with the visual high-fidelity of diffusion models. This hybrid technology ensures that characters and objects maintain structural integrity even during rapid movement or occlusion, without deformation or disappearance.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Strong Prompt Adherence',
        feature3Description: 'The model\'s execution of complex prompts has reached new heights, accurately restoring every detail described by users, including composition, lighting style, and interaction relationships between multiple subjects, achieving "what you think is what you get".',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Micro-detail Temporal Consistency',
        feature4Description: 'Focuses on maintaining the stability of tiny details across time dimensions. Whether it\'s the flutter of hair, ripples on water, or skin texture, everything remains coherent throughout the video segment, eliminating the common "flickering" phenomenon in traditional models.',

        // How to use section
        howToUseTitle: 'How to Use on 微鲤AI',
        step1Title: 'Log in to Workspace',
        step1Description: 'Enter the 微鲤AI creation workspace and click on the "Video Models" library in the left navigation bar.',
        step2Title: 'Select Model',
        step2Description: 'Find and select Runway Gen-4.5 (marked as New) in the model list.',
        step3Title: 'Enter Description',
        step3Description: 'Enter your detailed prompt in the text box (recommended to include action, lighting, and physical state descriptions), or upload a reference image to use the "Image to Video" feature.',
        step4Title: 'Adjust Settings and Generate',
        step4Description: 'Set video aspect ratio (such as 16:9) and duration (supports 5s or 10s), then click "Generate Now" to get high-definition video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos',

        // X Posts section
        xPostsTitle: 'X Posts',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Runway Gen-4.5?',
        faq1Answer: 'It is Runway\'s latest flagship text-to-video model, known for its excellent physics simulation capabilities and image stability, currently ranking first in industry benchmark tests.',
        faq2Question: 'What\'s the difference between it and Gen-4?',
        faq2Answer: 'Gen-4.5 introduces the A2D hybrid architecture. Compared to Gen-4, it has significant improvements in the physical realism of object movement (such as gravity and inertia), temporal consistency of images, and understanding of complex prompts.',
        faq3Question: 'What is the video duration?',
        faq3Answer: 'Currently, Gen-4.5 supports generating high-definition video clips up to 10 seconds, which is very suitable for creating short videos, advertising shots, or film pre-visualization (Previs).',
        faq4Question: 'Do I need to pay to use it on 微鲤AI?',
        faq4Answer: '微鲤AI provides free trial credits for new users. Since Gen-4.5 has higher computing costs, it consumes slightly more credits than older models. It is recommended to upgrade to Pro membership to get more generation times.',
        faq5Question: 'Does it support "Image to Video"?',
        faq5Answer: 'Yes. Gen-4.5\'s image-to-video feature is very powerful, able to perfectly preserve the style and character features of the reference image and make them move naturally.',
        faq6Question: 'What types of projects is it suitable for?',
        faq6Answer: 'Very suitable for commercial advertisements pursuing cinematic quality, visual effects (VFX) pre-visualization, complex physical dynamics displays (such as fluids and explosions), and narrative short film creation.',

        // CTA section
        ctaTitle: 'Experience Runway Gen-4.5 Now',
        ctaDescription: 'Try Runway Gen-4.5 for free on 微鲤AI and create AI videos beyond imagination',
        ctaButton: 'Start Creating',
        ctaDisclaimer: 'No credit card required · Free trial for new users',
    },
    ja: {
        // ジェネレーター部分
        generatorTitle: 'Runway Gen-4.5 AI動画ジェネレーター',
        generatorDescription: 'Runway Gen-4.5は、Runway社が2025年12月にリリースした最新のフラグシップAI動画生成モデルで、生成動画技術の「新フロンティア」を代表しています。Gen-4シリーズの大幅なアップグレードとして、このモデルは画期的な「自己回帰拡散（Autoregressive-to-Diffusion, A2D）」ハイブリッドアーキテクチャを導入し、物理法則のシミュレーションと長期時系列一貫性における従来モデルの課題を完全に解決しました。Artificial Analysisの動画アリーナで1247のEloスコアで首位を獲得しただけでなく、流体力学、重力感知、複雑な光と影の精密な再現により、プロクリエイターの第一選択肢となっています。WeryAIでRunway Gen-4.5を無料で体験し、現実を超越した映像創造力を感じてください！',
        
        // タブ
        tabImageToVideo: '画像から動画',

        // コア機能部分
        coreFeaturesTitle: 'Runway Gen-4.5 コア機能',
        coreFeaturesSubtitle: 'Runway Gen-4.5動画ジェネレーターの物理エンジンとハイブリッドアーキテクチャを深く理解し、精密で制御可能な映画級の創作を体験してください。',

        // 機能1: 物理法則シミュレーションエンジン
        feature1Title: '物理法則シミュレーションエンジン',
        feature1Description: 'Gen-4.5の最も顕著な向上は、現実世界の物理法則への深い理解にあります。物体の重量、運動量、衝突、および複雑な流体力学効果を正確にシミュレートし、AI動画でよく見られる「浮遊感」と反直感的な動きを完全に排除します。',

        // 機能2: 自己回帰拡散ハイブリッドアーキテクチャ
        feature2Title: '自己回帰拡散ハイブリッドアーキテクチャ',
        feature2Description: '自己回帰モデルのシーン理解能力と拡散モデルの視覚的高忠実度を組み合わせています。このハイブリッド技術により、キャラクターや物体が高速運動や遮蔽状況下でも構造的完全性を維持し、変形や消失が発生しません。',

        // 機能3: 超強力なプロンプト遵守
        feature3Title: '超強力なプロンプト遵守',
        feature3Description: 'モデルは複雑なプロンプトの実行において新たな高みに達し、構図、照明スタイル、複数の主体間の相互作用関係など、ユーザーが記述するすべての詳細を正確に再現し、「思うがままに得られる」を実現します。',

        // 機能4: 微細な詳細の時系列一貫性
        feature4Title: '微細な詳細の時系列一貫性',
        feature4Description: '時間次元における微小な詳細の安定性の維持に焦点を当てています。髪の毛の揺れ、水面の波紋、肌の質感など、すべてが動画セグメント全体で一貫して保たれ、従来のモデルでよく見られる「ちらつき」現象を排除します。',

        // 使用方法部分
        howToUseTitle: 'WeryAIでの使用方法',
        step1Title: 'ワークスペースにログイン',
        step1Description: 'WeryAI創作ワークスペースに入り、左側のナビゲーションバーで「動画モデル」ライブラリをクリックします。',
        step2Title: 'モデルを選択',
        step2Description: 'モデルリストでRunway Gen-4.5（Newとマーク）を見つけて選択します。',
        step3Title: '説明を入力',
        step3Description: 'テキストボックスに詳細なプロンプトを入力（動作、照明、物理状態の説明を含めることを推奨）、または参照画像をアップロードして「画像から動画」機能を使用します。',
        step4Title: '設定を調整して生成',
        step4Description: '動画のアスペクト比（16:9など）と長さ（5秒または10秒をサポート）を設定し、「今すぐ生成」をクリックして高解像度動画を取得します。',

        // YouTube動画部分
        youtubeTitle: 'YouTube動画',

        // X投稿部分
        xPostsTitle: 'X投稿',

        // 他のモデル探索部分
        exploreModelsTitle: 'WeryAI上の他の動画モデルを探索',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ部分
        faqTitle: 'よくある質問',
        faq1Question: 'Runway Gen-4.5とは何ですか？',
        faq1Answer: 'Runwayが最新リリースしたフラグシップテキストから動画へのモデルで、卓越した物理法則シミュレーション能力と画像の安定性で知られ、現在業界ベンチマークテストで首位を獲得しています。',
        faq2Question: 'Gen-4との違いは何ですか？',
        faq2Answer: 'Gen-4.5はA2Dハイブリッドアーキテクチャを導入しています。Gen-4と比較して、物体の動きの物理的リアリズム（重力や慣性など）、画像の時系列一貫性、複雑なプロンプトの理解において大幅な改善があります。',
        faq3Question: '動画の長さはどれくらいですか？',
        faq3Answer: '現在、Gen-4.5は最大10秒の高解像度動画クリップの生成をサポートしており、ショート動画、広告ショット、または映画のプレビジュアライゼーション（Previs）の作成に非常に適しています。',
        faq4Question: 'WeryAIで使用するには支払いが必要ですか？',
        faq4Answer: 'WeryAIは新規ユーザーに無料トライアルクレジットを提供しています。Gen-4.5は計算コストが高いため、旧モデルよりもわずかに多くのクレジットを消費します。より多くの生成回数を得るには、Proメンバーシップへのアップグレードをお勧めします。',
        faq5Question: '「画像から動画」をサポートしていますか？',
        faq5Answer: 'はい。Gen-4.5の画像から動画への機能は非常に強力で、参照画像のスタイルとキャラクター特徴を完璧に保持し、自然に動かすことができます。',
        faq6Question: 'どのようなタイプのプロジェクトに適していますか？',
        faq6Answer: '映画的な品質を追求する商業広告、視覚効果（VFX）プレビジュアライゼーション、複雑な物理動力学表示（流体や爆発など）、および物語性のある短編映画の作成に非常に適しています。',

        // CTA部分
        ctaTitle: '今すぐRunway Gen-4.5を体験',
        ctaDescription: 'WeryAIでRunway Gen-4.5を無料で試し、想像を超えるAI動画を作成',
        ctaButton: '創作を開始',
        ctaDisclaimer: 'クレジットカード不要 · 新規ユーザー無料体験',
    },
    ko: {
        // 생성기 부분
        generatorTitle: 'Runway Gen-4.5 AI 비디오 생성기',
        generatorDescription: 'Runway Gen-4.5는 Runway사가 2025년 12월에 출시한 최신 플래그십 AI 비디오 생성 모델로, 생성형 비디오 기술의 "새로운 프론티어"를 대표합니다. Gen-4 시리즈의 주요 업그레이드로서, 이 모델은 획기적인 "자기회귀 확산(Autoregressive-to-Diffusion, A2D)" 하이브리드 아키텍처를 도입하여 물리 법칙 시뮬레이션 및 장기 시간 일관성에서 기존 모델의 문제점을 완전히 해결했습니다. Artificial Analysis의 비디오 아레나에서 1247의 Elo 점수로 1위를 차지했을 뿐만 아니라, 유체 역학, 중력 감지 및 복잡한 조명의 정밀한 복원으로 인해 전문 크리에이터의 첫 번째 선택이 되었습니다. WeryAI에서 Runway Gen-4.5를 무료로 체험하고 현실을 초월한 영상 창조력을 느껴보세요!',
        
        // 탭
        tabImageToVideo: '이미지에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Runway Gen-4.5 핵심 기능',
        coreFeaturesSubtitle: 'Runway Gen-4.5 비디오 생성기의 물리 엔진과 하이브리드 아키텍처를 깊이 이해하고, 정밀하고 제어 가능한 영화급 창작을 체험하세요.',

        // 기능1: 물리 법칙 시뮬레이션 엔진
        feature1Title: '물리 법칙 시뮬레이션 엔진',
        feature1Description: 'Gen-4.5의 가장 중요한 개선은 실제 세계 물리 법칙에 대한 깊은 이해에 있습니다. 물체의 무게, 운동량, 충돌 및 복잡한 유체 역학 효과를 정확하게 시뮬레이션하여 AI 비디오에서 흔히 볼 수 있는 "떠다니는 느낌"과 반직관적인 움직임을 완전히 제거합니다.',

        // 기능2: 자기회귀 확산 하이브리드 아키텍처
        feature2Title: '자기회귀 확산 하이브리드 아키텍처',
        feature2Description: '자기회귀 모델의 장면 이해 능력과 확산 모델의 시각적 고충실도를 결합합니다. 이 하이브리드 기술은 캐릭터와 물체가 빠른 움직임이나 가림 상황에서도 구조적 무결성을 유지하며, 변형이나 사라짐이 발생하지 않도록 보장합니다.',

        // 기능3: 초강력 프롬프트 준수
        feature3Title: '초강력 프롬프트 준수',
        feature3Description: '모델은 복잡한 프롬프트의 실행에서 새로운 높이에 도달하여, 구도, 조명 스타일 및 여러 주체 간의 상호작용 관계를 포함한 사용자가 설명하는 모든 세부 사항을 정확하게 복원하며 "생각한 대로 얻는다"를 실현합니다.',

        // 기능4: 미세 세부 사항 시간 일관성
        feature4Title: '미세 세부 사항 시간 일관성',
        feature4Description: '시간 차원에서 미세한 세부 사항의 안정성 유지에 초점을 맞춥니다. 머리카락의 흔들림, 물 표면의 파문, 피부 질감 등 모든 것이 비디오 세그먼트 전체에서 일관되게 유지되며, 전통적인 모델에서 흔히 볼 수 있는 "깜빡임" 현상을 제거합니다.',

        // 사용 방법 부분
        howToUseTitle: 'WeryAI에서 사용 방법',
        step1Title: '작업 공간에 로그인',
        step1Description: '微鲤AI 창작 작업 공간에 들어가 왼쪽 탐색 바에서 "비디오 모델" 라이브러리를 클릭합니다.',
        step2Title: '모델 선택',
        step2Description: '모델 목록에서 Runway Gen-4.5(New로 표시)를 찾아 선택합니다.',
        step3Title: '설명 입력',
        step3Description: '텍스트 상자에 상세한 프롬프트를 입력(동작, 조명, 물리 상태 설명 포함 권장)하거나 참조 이미지를 업로드하여 "이미지에서 비디오" 기능을 사용합니다.',
        step4Title: '설정 조정 및 생성',
        step4Description: '비디오 종횡비(예: 16:9)와 길이(5초 또는 10초 지원)를 설정한 다음 "지금 생성"을 클릭하여 고해상도 비디오를 얻습니다.',

        // YouTube 비디오 부분
        youtubeTitle: 'YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: 'WeryAI의 다른 비디오 모델 탐색',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Runway Gen-4.5가 무엇인가요?',
        faq1Answer: 'Runway가 최신으로 출시한 플래그십 텍스트-비디오 모델로, 우수한 물리 시뮬레이션 기능과 이미지 안정성으로 유명하며, 현재 업계 벤치마크 테스트에서 1위를 차지하고 있습니다.',
        faq2Question: 'Gen-4와의 차이점은 무엇인가요?',
        faq2Answer: 'Gen-4.5는 A2D 하이브리드 아키텍처를 도입했습니다. Gen-4와 비교하여 물체 움직임의 물리적 현실감(중력 및 관성 등), 이미지의 시간 일관성, 복잡한 프롬프트 이해에서 상당한 개선이 있습니다.',
        faq3Question: '비디오 길이는 얼마나 되나요?',
        faq3Answer: '현재 Gen-4.5는 최대 10초의 고해상도 비디오 클립 생성을 지원하며, 짧은 비디오, 광고 샷 또는 영화 사전 시각화(Previs) 제작에 매우 적합합니다.',
        faq4Question: 'WeryAI에서 사용하려면 결제가 필요하나요?',
        faq4Answer: 'WeryAI는 신규 사용자에게 무료 체험 크레딧을 제공합니다. Gen-4.5는 계산 비용이 높기 때문에 이전 모델보다 약간 더 많은 크레딧을 소비합니다. 더 많은 생성 횟수를 얻으려면 Pro 멤버십으로 업그레이드하는 것이 좋습니다.',
        faq5Question: '"이미지에서 비디오"를 지원하나요?',
        faq5Answer: '네. Gen-4.5의 이미지-비디오 기능은 매우 강력하여 참조 이미지의 스타일과 캐릭터 특징을 완벽하게 보존하고 자연스럽게 움직이게 할 수 있습니다.',
        faq6Question: '어떤 유형의 프로젝트에 적합한가요?',
        faq6Answer: '영화적 품질을 추구하는 상업 광고, 시각 효과(VFX) 사전 시각화, 복잡한 물리 역학 표시(유체 및 폭발 등), 그리고 서사적 단편 영화 제작에 매우 적합합니다.',

        // CTA 부분
        ctaTitle: '지금 Runway Gen-4.5 체험',
        ctaDescription: 'WeryAI에서 Runway Gen-4.5를 무료로 시도하고 상상을 초월하는 AI 비디오 만들기',
        ctaButton: '창작 시작',
        ctaDisclaimer: '신용카드 불필요 · 신규 사용자 무료 체험',
    },
    tw: {
        // 生成器部分
        generatorTitle: 'Runway Gen-4.5 AI 影片產生器',
        generatorDescription:
            'Runway Gen-4.5 是 Runway 公司於 2025 年 12 月推出的最新旗艦級 AI 影片生成模型，代表了生成式影片技術的「新前沿」。作為 Gen-4 系列的重大升級，該模型引入了突破性的「自回歸擴散（Autoregressive-to-Diffusion, A2D）」混合架構，徹底解決了以往模型在物理規律模擬和長時序一致性上的痛點。它不僅在 Artificial Analysis 的影片競技場中以 1247 的 Elo 分數位居榜首，更因其對流體動力學、重力感應及複雜光影的精準還原而成為專業創作者的首選。快來 微鲤AI 免費體驗 Runway Gen-4.5，感受超越現實的影像創造力！',

        // 標籤頁
        tabImageToVideo: '圖生影片',

        // 核心功能部分
        coreFeaturesTitle: 'Runway Gen-4.5 核心功能',
        coreFeaturesSubtitle:
            '深入了解 Runway Gen-4.5 影片產生器的物理引擎與混合架構，體驗精準可控的電影級創作。',

        // 功能1: 物理規律模擬引擎
        feature1Title: '物理規律模擬引擎',
        feature1Description:
            'Gen-4.5 最顯著的提升在於對真實世界物理法則的深刻理解。它能準確模擬物體的重量、動量、碰撞以及複雜的流體動力學效果，徹底告別 AI 影片中常見的「漂浮感」和反直覺運動。',

        // 功能2: 自回歸擴散混合架構
        feature2Title: '自回歸擴散混合架構',
        feature2Description:
            '結合了自回歸模型的場景理解能力和擴散模型的視覺高保真度。這種混合技術確保了角色和物體在快速運動或遮擋情況下，依然保持結構完整，不會發生形變或消失。',

        // 功能3: 超強提示詞依從性
        feature3Title: '超強提示詞依從性',
        feature3Description:
            '模型對複雜提示詞的執行力達到了新高度，能夠精準還原用戶描述的每一個細節，包括構圖、光照風格及多主體間的互動關係，「所想即所得」。',

        // 功能4: 微觀細節時序一致性
        feature4Title: '微觀細節時序一致性',
        feature4Description:
            '專注於維持微小細節在時間維度上的穩定性。無論是髮絲的飄動、水面的波紋還是皮膚的質感，都能在整個影片片段中保持連貫，消除了傳統模型常見的「閃爍」現象。',

        // 如何使用部分
        howToUseTitle: '如何在 微鲤AI 上使用',
        step1Title: '登錄工作台',
        step1Description: '進入 微鲤AI 創作工作台，在左側導航欄點擊「影片模型」庫。',
        step2Title: '選擇模型',
        step2Description: '在模型列表中找到並選中 Runway Gen-4.5（標記為 New）。',
        step3Title: '輸入描述',
        step3Description:
            '在文本框中輸入您的詳細提示詞（建議包含動作、光影和物理狀態描述），或上傳參考圖以使用「圖生影片」功能。',
        step4Title: '調整設置與生成',
        step4Description:
            '設置影片比例（如 16:9）和時長（支持 5s 或 10s），點擊「立即生成」即可獲取高清影片。',

        // YouTube 影片部分
        youtubeTitle: 'YouTube 影片',

        // X 推文部分
        xPostsTitle: 'X 貼文',

        // 探索其他模型部分
        exploreModelsTitle: '探索 微鲤AI 上的其他影片模型',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ 部分
        faqTitle: '常見問題解答',
        faq1Question: 'Runway Gen-4.5 是什麼？',
        faq1Answer:
            '它是 Runway 最新發佈的旗艦級文生影片模型，以其卓越的物理規律模擬能力和畫面穩定性著称，目前在行業基準測試中排名第一。',
        faq2Question: '它和 Gen-4 有什麼區別？',
        faq2Answer:
            'Gen-4.5 引入了 A2D 混合架構，相比 Gen-4，它在物體運動的物理真實感（如重力、慣性）、畫面的時序一致性以及對複雜提示詞的理解上有顯著提升。',
        faq3Question: '生成影片的時長是多少？',
        faq3Answer:
            '目前 Gen-4.5 支持生成最高 10 秒的高清影片片段，非常適合製作短影片、廣告鏡頭或電影預演（Previs）。',
        faq4Question: '在 微鲤AI 上使用需要付費嗎？',
        faq4Answer:
            '微鲤AI 為新用戶提供免費體驗額度。由於 Gen-4.5 算力成本較高，消耗的積分會略多於舊版模型，建議升級 Pro 會員以獲取更多生成次數。',
        faq5Question: '它支持「圖生影片」嗎？',
        faq5Answer:
            '支持。Gen-4.5 的圖生影片功能非常強大，能夠完美保留參考圖的風格和角色特徵，並讓其自然地動起來。',
        faq6Question: '適合什麼樣的項目？',
        faq6Answer:
            '非常適合追求電影質感的商業廣告、視覺特效（VFX）預演、複雜的物理動態展示（如流體、爆炸）以及敘事類短片創作。',

        // CTA 部分
        ctaTitle: '立即體驗 Runway Gen-4.5',
        ctaDescription: '在 微鲤AI 上免費試用 Runway Gen-4.5，創造超越想像的 AI 影片',
        ctaButton: '開始創作',
        ctaDisclaimer: '無需信用卡 · 新用戶免費體驗',
    },
    pl: {
        // Generator section
        generatorTitle: 'Generator wideo AI Runway Gen-4.5',
        generatorDescription:
            'Runway Gen-4.5 to najnowszy flagowy model generowania wideo AI firmy Runway, wprowadzony na rynek w grudniu 2025 roku, reprezentujący "nową granicę" technologii generatywnego wideo. Jako główna aktualizacja serii Gen-4, model ten wprowadza przełomową architekturę hybrydową "Autoregressive-to-Diffusion (A2D)", która całkowicie rozwiązuje bolączki poprzednich modeli w zakresie symulacji praw fizyki i długoterminowej spójności czasowej. Nie tylko zajmuje pierwsze miejsce na arenie wideo Artificial Analysis z wynikiem Elo 1247, ale także staje się pierwszym wyborem dla profesjonalnych twórców dzięki precyzyjnemu odtwarzaniu dynamiki płynów, wyczuwaniu grawitacji i złożonemu oświetleniu. Zapraszamy do 微鲤AI, aby bezpłatnie wypróbować Runway Gen-4.5 i poczuć kreatywną moc obrazów wykraczających poza rzeczywistość!',

        // Tabs
        tabImageToVideo: 'Obraz na wideo',

        // Core features section
        coreFeaturesTitle: 'Kluczowe funkcje Runway Gen-4.5',
        coreFeaturesSubtitle:
            'Zgłęb wiedzę o silniku fizycznym i architekturze hybrydowej generatora wideo Runway Gen-4.5, poznaj precyzyjne i kontrolowane tworzenie treści kinowych.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Silnik symulacji fizyki',
        feature1Description:
            'Najważniejszym ulepszeniem Gen-4.5 jest głębokie zrozumienie praw fizyki świata rzeczywistego. Potrafi on dokładnie symulować wagę obiektów, pęd, kolizje i złożone efekty dynamiki płynów, całkowicie eliminując powszechne w filmach AI uczucie "pływania" i ruchy sprzeczne z intuicją.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Hybrydowa architektura Autoregressive-to-Diffusion',
        feature2Description:
            'Łączy zdolność rozumienia sceny modeli autoregresyjnych z wysoką wiernością wizualną modeli dyfuzyjnych. Ta hybrydowa technologia zapewnia, że postacie i obiekty zachowują integralność strukturalną nawet podczas szybkiego ruchu lub przesłonięcia, bez deformacji i znikania.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Silne przestrzeganie promptów',
        feature3Description:
            'Wykonanie złożonych promptów przez model osiągnęło nowy poziom, dokładnie odtwarzając każdy szczegół opisany przez użytkowników, w tym kompozycję, styl oświetlenia i relacje interakcji między wieloma obiektami, osiągając efekt "dostajesz to, o czym myślisz".',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Spójność czasowa mikro-detali',
        feature4Description:
            'Koncentruje się na utrzymaniu stabilności drobnych szczegółów w wymiarze czasowym. Niezależnie od tego, czy chodzi o powiew włosów, zmarszczki na wodzie czy teksturę skóry, wszystko pozostaje spójne w całym segmencie wideo, eliminując powszechne w tradycyjnych modelach zjawisko "migotania".',

        // How to use section
        howToUseTitle: 'Jak używać w 微鲤AI',
        step1Title: 'Zaloguj się do obszaru roboczego',
        step1Description:
            'Wejdź do obszaru roboczego kreatywnego 微鲤AI i kliknij bibliotekę "Modele wideo" na lewym pasku nawigacyjnym.',
        step2Title: 'Wybierz model',
        step2Description: 'Znajdź i wybierz Runway Gen-4.5 (oznaczony jako New) na liście modeli.',
        step3Title: 'Wprowadź opis',
        step3Description:
            'Wprowadź swój szczegółowy prompt w polu tekstowym (zalecamy uwzględnienie opisów akcji, oświetlenia i stanu fizycznego) lub prześlij obraz referencyjny, aby użyć funkcji "Obraz na wideo".',
        step4Title: 'Dostosuj ustawienia i generuj',
        step4Description:
            'Ustaw proporcje wideo (np. 16:9) i czas trwania (obsługuje 5s lub 10s), a następnie kliknij "Generuj teraz", aby uzyskać wideo wysokiej jakości.',

        // YouTube videos section
        youtubeTitle: 'Filmy na YouTube',

        // X Posts section
        xPostsTitle: 'Posty na X',

        // Explore other models section
        exploreModelsTitle: 'Poznaj inne modele wideo w 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Często zadawane pytania',
        faq1Question: 'Co to jest Runway Gen-4.5?',
        faq1Answer:
            'Jest to najnowszy flagowy model Runway typu text-to-video, znany z doskonałych możliwości symulacji fizyki i stabilności obrazu, obecnie zajmujący pierwsze miejsce w testach porównawczych branży.',
        faq2Question: 'Jaka jest różnica między nim a Gen-4?',
        faq2Answer:
            'Gen-4.5 wprowadza architekturę hybrydową A2D. W porównaniu do Gen-4 oferuje znaczące ulepszenia w fizycznym realizmie ruchu obiektów (takich jak grawitacja i inercja), spójności czasowej obrazów oraz rozumieniu złożonych promptów.',
        faq3Question: 'Jaki jest czas trwania wideo?',
        faq3Answer:
            'Obecnie Gen-4.5 obsługuje generowanie klipów wideo wysokiej rozdzielczości o długości do 10 sekund, co doskonale nadaje się do tworzenia krótkich filmów, ujęć reklamowych czy prewizualizacji filmowych (Previs).',
        faq4Question: 'Czy muszę płacić za korzystanie z niego w 微鲤AI?',
        faq4Answer:
            '微鲤AI zapewnia darmowe kredyty próbne dla nowych użytkowników. Ponieważ Gen-4.5 ma wyższe koszty obliczeniowe, zużywa nieco więcej kredytów niż starsze modele. Zalecamy przejście na członkostwo Pro, aby uzyskać więcej możliwości generowania.',
        faq5Question: 'Czy obsługuje funkcję "Obraz na wideo"?',
        faq5Answer:
            'Tak. Funkcja obraz-na-wideo w Gen-4.5 jest bardzo potężna, pozwala idealnie zachować styl i cechy postaci z obrazu referencyjnego oraz nadać im naturalny ruch.',
        faq6Question: 'Dla jakich projektów jest odpowiedni?',
        faq6Answer:
            'Bardzo odpowiedni dla reklam komercyjnych dążących do kinowej jakości, prewizualizacji efektów wizualnych (VFX), złożonych pokazów dynamiki fizycznej (takich jak płyny i eksplozje) oraz tworzenia narracyjnych filmów krótkometrażowych.',

        // CTA section
        ctaTitle: 'Wypróbuj Runway Gen-4.5 już teraz',
        ctaDescription:
            'Wypróbuj Runway Gen-4.5 za darmo w 微鲤AI i twórz filmy AI wykraczające poza wyobraźnię',
        ctaButton: 'Zacznij tworzyć',
        ctaDisclaimer: 'Karta kredytowa nie jest wymagana · Darmowy okres próbny dla nowych użytkowników',
    },
    es: {
        // Sección del generador
        generatorTitle: 'Generador de videos con IA Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 es el último modelo insignia de generación de videos con IA lanzado por Runway en diciembre de 2025, representando la "nueva frontera" de la tecnología de video generativo. Como una actualización importante de la serie Gen-4, este modelo introduce una arquitectura híbrida innovadora "Autoregresivo a Difusión (A2D)" que resuelve completamente los puntos débiles de los modelos anteriores en la simulación de leyes físicas y la consistencia temporal a largo plazo. No solo ocupa el primer lugar en la arena de videos de Artificial Analysis con una puntuación Elo de 1247, sino que también se convierte en la primera opción para creadores profesionales debido a su restauración precisa de dinámica de fluidos, detección de gravedad e iluminación compleja. ¡Ven a 微鲤AI para experimentar Runway Gen-4.5 gratis y siente el poder creativo de imágenes más allá de la realidad!',
        
        // Pestañas
        tabImageToVideo: 'Imagen a video',

        // Sección de funciones principales
        coreFeaturesTitle: 'Funciones principales de Runway Gen-4.5',
        coreFeaturesSubtitle: 'Profundiza en el motor de física y la arquitectura híbrida del generador de videos Runway Gen-4.5, experimenta la creación cinematográfica precisa y controlable.',

        // Función 1: Motor de simulación de leyes físicas
        feature1Title: 'Motor de simulación de leyes físicas',
        feature1Description: 'La mejora más significativa de Gen-4.5 radica en su profunda comprensión de las leyes físicas del mundo real. Puede simular con precisión el peso de los objetos, el momento, las colisiones y los efectos complejos de dinámica de fluidos, eliminando por completo la sensación común de "flotación" y el movimiento contraintuitivo en los videos con IA.',

        // Función 2: Arquitectura híbrida autoregresiva-difusión
        feature2Title: 'Arquitectura híbrida autoregresiva-difusión',
        feature2Description: 'Combina la capacidad de comprensión de escenas de los modelos autoregresivos con la alta fidelidad visual de los modelos de difusión. Esta tecnología híbrida asegura que los personajes y objetos mantengan la integridad estructural incluso durante movimientos rápidos u oclusión, sin deformación o desaparición.',

        // Función 3: Fuerte adherencia al prompt
        feature3Title: 'Fuerte adherencia al prompt',
        feature3Description: 'La ejecución del modelo de prompts complejos ha alcanzado nuevas alturas, restaurando con precisión cada detalle descrito por los usuarios, incluyendo composición, estilo de iluminación y relaciones de interacción entre múltiples sujetos, logrando "lo que piensas es lo que obtienes".',

        // Función 4: Consistencia temporal de micro-detalles
        feature4Title: 'Consistencia temporal de micro-detalles',
        feature4Description: 'Se enfoca en mantener la estabilidad de detalles diminutos a través de las dimensiones temporales. Ya sea el movimiento del cabello, las ondas en el agua o la textura de la piel, todo permanece coherente a lo largo del segmento de video, eliminando el fenómeno común de "parpadeo" en los modelos tradicionales.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo usar en 微鲤AI',
        step1Title: 'Iniciar sesión en el espacio de trabajo',
        step1Description: 'Ingresa al espacio de trabajo de creación de 微鲤AI y haz clic en la biblioteca "Modelos de video" en la barra de navegación izquierda.',
        step2Title: 'Seleccionar modelo',
        step2Description: 'Encuentra y selecciona Runway Gen-4.5 (marcado como New) en la lista de modelos.',
        step3Title: 'Ingresar descripción',
        step3Description: 'Ingresa tu prompt detallado en el cuadro de texto (se recomienda incluir descripciones de acción, iluminación y estado físico), o sube una imagen de referencia para usar la función "Imagen a video".',
        step4Title: 'Ajustar configuración y generar',
        step4Description: 'Establece la relación de aspecto del video (como 16:9) y la duración (admite 5s o 10s), luego haz clic en "Generar ahora" para obtener video de alta definición.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube',

        // Sección de publicaciones en X
        xPostsTitle: 'Publicaciones en X',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar otros modelos de video en 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas frecuentes',
        faq1Question: '¿Qué es Runway Gen-4.5?',
        faq1Answer: 'Es el último modelo insignia de texto a video lanzado por Runway, conocido por sus excelentes capacidades de simulación física y estabilidad de imagen, actualmente ocupando el primer lugar en las pruebas de referencia de la industria.',
        faq2Question: '¿Cuál es la diferencia con Gen-4?',
        faq2Answer: 'Gen-4.5 introduce la arquitectura híbrida A2D. En comparación con Gen-4, tiene mejoras significativas en el realismo físico del movimiento de objetos (como gravedad e inercia), la consistencia temporal de las imágenes y la comprensión de prompts complejos.',
        faq3Question: '¿Cuál es la duración del video?',
        faq3Answer: 'Actualmente, Gen-4.5 admite la generación de clips de video de alta definición de hasta 10 segundos, muy adecuado para crear videos cortos, tomas publicitarias o previsualización cinematográfica (Previs).',
        faq4Question: '¿Necesito pagar para usarlo en 微鲤AI?',
        faq4Answer: '微鲤AI proporciona créditos de prueba gratuitos para nuevos usuarios. Dado que Gen-4.5 tiene costos de computación más altos, consume un poco más de créditos que los modelos anteriores. Se recomienda actualizar a la membresía Pro para obtener más veces de generación.',
        faq5Question: '¿Admite "Imagen a video"?',
        faq5Answer: 'Sí. La función de imagen a video de Gen-4.5 es muy poderosa, capaz de preservar perfectamente el estilo y las características del personaje de la imagen de referencia y hacer que se muevan naturalmente.',
        faq6Question: '¿Para qué tipos de proyectos es adecuado?',
        faq6Answer: 'Muy adecuado para anuncios comerciales que buscan calidad cinematográfica, previsualización de efectos visuales (VFX), exhibiciones de dinámica física compleja (como fluidos y explosiones) y creación de cortometrajes narrativos.',

        // Sección CTA
        ctaTitle: 'Experimenta Runway Gen-4.5 ahora',
        ctaDescription: 'Prueba Runway Gen-4.5 gratis en 微鲤AI y crea videos con IA más allá de la imaginación',
        ctaButton: 'Comenzar a crear',
        ctaDisclaimer: 'No se requiere tarjeta de crédito · Prueba gratuita para nuevos usuarios',
    },
    fr: {
        // Section du générateur
        generatorTitle: 'Générateur vidéo IA Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 est le dernier modèle phare de génération vidéo IA lancé par Runway en décembre 2025, représentant la "nouvelle frontière" de la technologie vidéo générative. En tant que mise à niveau majeure de la série Gen-4, ce modèle introduit une architecture hybride révolutionnaire "Autoregressive-to-Diffusion (A2D)" qui résout complètement les points faibles des modèles précédents dans la simulation des lois physiques et la cohérence temporelle à long terme. Il occupe non seulement la première place dans l\'arène vidéo d\'Artificial Analysis avec un score Elo de 1247, mais devient également le premier choix pour les créateurs professionnels en raison de sa restauration précise de la dynamique des fluides, de la détection de la gravité et de l\'éclairage complexe. Venez sur 微鲤AI pour expérimenter Runway Gen-4.5 gratuitement et ressentir le pouvoir créatif des images au-delà de la réalité !',
        
        // Onglets
        tabImageToVideo: 'Image vers vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités principales de Runway Gen-4.5',
        coreFeaturesSubtitle: 'Plongez dans le moteur physique et l\'architecture hybride du générateur vidéo Runway Gen-4.5, expérimentez la création cinématographique précise et contrôlable.',

        // Fonctionnalité 1: Moteur de simulation des lois physiques
        feature1Title: 'Moteur de simulation des lois physiques',
        feature1Description: 'L\'amélioration la plus significative de Gen-4.5 réside dans sa compréhension approfondie des lois physiques du monde réel. Il peut simuler avec précision le poids des objets, la quantité de mouvement, les collisions et les effets complexes de dynamique des fluides, éliminant complètement la sensation commune de "flottement" et le mouvement contre-intuitif dans les vidéos IA.',

        // Fonctionnalité 2: Architecture hybride autoregressive-diffusion
        feature2Title: 'Architecture hybride autoregressive-diffusion',
        feature2Description: 'Combine la capacité de compréhension de scène des modèles autoregressifs avec la haute fidélité visuelle des modèles de diffusion. Cette technologie hybride garantit que les personnages et les objets maintiennent l\'intégrité structurelle même pendant les mouvements rapides ou l\'occlusion, sans déformation ou disparition.',

        // Fonctionnalité 3: Forte adhérence au prompt
        feature3Title: 'Forte adhérence au prompt',
        feature3Description: 'L\'exécution du modèle de prompts complexes a atteint de nouveaux sommets, restaurant avec précision chaque détail décrit par les utilisateurs, y compris la composition, le style d\'éclairage et les relations d\'interaction entre plusieurs sujets, réalisant "ce que vous pensez est ce que vous obtenez".',

        // Fonctionnalité 4: Cohérence temporelle des micro-détails
        feature4Title: 'Cohérence temporelle des micro-détails',
        feature4Description: 'Se concentre sur le maintien de la stabilité des détails minuscules à travers les dimensions temporelles. Qu\'il s\'agisse du mouvement des cheveux, des ondulations sur l\'eau ou de la texture de la peau, tout reste cohérent tout au long du segment vidéo, éliminant le phénomène commun de "scintillement" dans les modèles traditionnels.',

        // Section comment utiliser
        howToUseTitle: 'Comment utiliser sur 微鲤AI',
        step1Title: 'Se connecter à l\'espace de travail',
        step1Description: 'Entrez dans l\'espace de création 微鲤AI et cliquez sur la bibliothèque "Modèles vidéo" dans la barre de navigation gauche.',
        step2Title: 'Sélectionner le modèle',
        step2Description: 'Trouvez et sélectionnez Runway Gen-4.5 (marqué comme New) dans la liste des modèles.',
        step3Title: 'Entrer la description',
        step3Description: 'Entrez votre prompt détaillé dans la zone de texte (il est recommandé d\'inclure des descriptions d\'action, d\'éclairage et d\'état physique), ou téléchargez une image de référence pour utiliser la fonction "Image vers vidéo".',
        step4Title: 'Ajuster les paramètres et générer',
        step4Description: 'Définissez le rapport d\'aspect vidéo (tel que 16:9) et la durée (prend en charge 5s ou 10s), puis cliquez sur "Générer maintenant" pour obtenir une vidéo haute définition.',

        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube',

        // Section publications X
        xPostsTitle: 'Publications X',

        // Section explorer d\'autres modèles
        exploreModelsTitle: 'Explorer d\'autres modèles vidéo sur 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // Section FAQ
        faqTitle: 'Questions fréquentes',
        faq1Question: 'Qu\'est-ce que Runway Gen-4.5 ?',
        faq1Answer: 'C\'est le dernier modèle phare texte-vidéo lancé par Runway, connu pour ses excellentes capacités de simulation physique et sa stabilité d\'image, occupant actuellement la première place dans les tests de référence de l\'industrie.',
        faq2Question: 'Quelle est la différence avec Gen-4 ?',
        faq2Answer: 'Gen-4.5 introduit l\'architecture hybride A2D. Par rapport à Gen-4, il présente des améliorations significatives dans le réalisme physique du mouvement des objets (tels que la gravité et l\'inertie), la cohérence temporelle des images et la compréhension des prompts complexes.',
        faq3Question: 'Quelle est la durée de la vidéo ?',
        faq3Answer: 'Actuellement, Gen-4.5 prend en charge la génération de clips vidéo haute définition jusqu\'à 10 secondes, très adapté pour créer des vidéos courtes, des plans publicitaires ou une prévisualisation cinématographique (Previs).',
        faq4Question: 'Dois-je payer pour l\'utiliser sur 微鲤AI ?',
        faq4Answer: '微鲤AI fournit des crédits d\'essai gratuits pour les nouveaux utilisateurs. Étant donné que Gen-4.5 a des coûts de calcul plus élevés, il consomme un peu plus de crédits que les modèles précédents. Il est recommandé de passer à l\'adhésion Pro pour obtenir plus de fois de génération.',
        faq5Question: 'Prend-il en charge "Image vers vidéo" ?',
        faq5Answer: 'Oui. La fonction image vers vidéo de Gen-4.5 est très puissante, capable de préserver parfaitement le style et les caractéristiques du personnage de l\'image de référence et de les faire bouger naturellement.',
        faq6Question: 'Pour quels types de projets est-il adapté ?',
        faq6Answer: 'Très adapté pour les publicités commerciales recherchant une qualité cinématographique, la prévisualisation d\'effets visuels (VFX), les affichages de dynamique physique complexe (tels que les fluides et les explosions) et la création de courts métrages narratifs.',

        // Section CTA
        ctaTitle: 'Expérimentez Runway Gen-4.5 maintenant',
        ctaDescription: 'Essayez Runway Gen-4.5 gratuitement sur 微鲤AI et créez des vidéos IA au-delà de l\'imagination',
        ctaButton: 'Commencer à créer',
        ctaDisclaimer: 'Aucune carte bancaire requise · Essai gratuit pour les nouveaux utilisateurs',
    },
    de: {
        // Generatorabschnitt
        generatorTitle: 'Runway Gen-4.5 KI-Videogenerator',
        generatorDescription: 'Runway Gen-4.5 ist Runways neuestes Flaggschiff-Modell für KI-Videogenerierung, das im Dezember 2025 auf den Markt kam und die "neue Grenze" der generativen Videotechnologie darstellt. Als bedeutendes Upgrade der Gen-4-Serie führt dieses Modell eine bahnbrechende "Autoregressive-to-Diffusion (A2D)" Hybridarchitektur ein, die die Schwachstellen früherer Modelle bei der Simulation physikalischer Gesetze und der langfristigen zeitlichen Konsistenz vollständig behebt. Es belegt nicht nur den ersten Platz in Artificial Analysis\' Video-Arena mit einer Elo-Punktzahl von 1247, sondern wird auch aufgrund seiner präzisen Wiederherstellung von Strömungsdynamik, Gravitationserkennung und komplexer Beleuchtung zur ersten Wahl für professionelle Kreative. Kommen Sie zu 微鲤AI, um Runway Gen-4.5 kostenlos zu erleben und die kreative Kraft von Bildern jenseits der Realität zu spüren!',
        
        // Tabs
        tabImageToVideo: 'Bild zu Video',

        // Abschnitt Kernfunktionen
        coreFeaturesTitle: 'Kernfunktionen von Runway Gen-4.5',
        coreFeaturesSubtitle: 'Tauchen Sie tief in die Physik-Engine und Hybridarchitektur des Runway Gen-4.5 Videogenerators ein und erleben Sie präzise und kontrollierbare kinematografische Kreation.',

        // Funktion 1: Physiksimulations-Engine
        feature1Title: 'Physiksimulations-Engine',
        feature1Description: 'Die bedeutendste Verbesserung von Gen-4.5 liegt in seinem tiefen Verständnis der physikalischen Gesetze der realen Welt. Es kann Objektgewicht, Impuls, Kollisionen und komplexe Strömungsdynamik-Effekte genau simulieren und eliminiert vollständig das häufige "Schwebegefühl" und kontraintuitive Bewegungen in KI-Videos.',

        // Funktion 2: Autoregressive-to-Diffusion Hybridarchitektur
        feature2Title: 'Autoregressive-to-Diffusion Hybridarchitektur',
        feature2Description: 'Kombiniert die Szenenverständnisfähigkeit autoregressiver Modelle mit der visuellen Hochfidelität von Diffusionsmodellen. Diese Hybridtechnologie stellt sicher, dass Charaktere und Objekte auch bei schneller Bewegung oder Verdeckung ihre strukturelle Integrität beibehalten, ohne Verformung oder Verschwinden.',

        // Funktion 3: Starke Prompt-Einhaltung
        feature3Title: 'Starke Prompt-Einhaltung',
        feature3Description: 'Die Ausführung komplexer Prompts durch das Modell hat neue Höhen erreicht und stellt jeden von Benutzern beschriebenen Detail präzise wieder her, einschließlich Komposition, Beleuchtungsstil und Interaktionsbeziehungen zwischen mehreren Subjekten, was "was Sie denken, ist was Sie bekommen" erreicht.',

        // Funktion 4: Mikro-Detail zeitliche Konsistenz
        feature4Title: 'Mikro-Detail zeitliche Konsistenz',
        feature4Description: 'Konzentriert sich auf die Aufrechterhaltung der Stabilität winziger Details über Zeitdimensionen hinweg. Ob es das Flattern der Haare, Wellen auf dem Wasser oder die Hauttextur ist, alles bleibt während des gesamten Videosegments kohärent und eliminiert das häufige "Flackern"-Phänomen in traditionellen Modellen.',

        // Abschnitt Anwendung
        howToUseTitle: 'So verwenden Sie es auf 微鲤AI',
        step1Title: 'Am Arbeitsbereich anmelden',
        step1Description: 'Betreten Sie den 微鲤AI-Erstellungsworkspace und klicken Sie in der linken Navigationsleiste auf die Bibliothek "Videomodelle".',
        step2Title: 'Modell auswählen',
        step2Description: 'Finden und wählen Sie Runway Gen-4.5 (als New markiert) in der Modellliste aus.',
        step3Title: 'Beschreibung eingeben',
        step3Description: 'Geben Sie Ihren detaillierten Prompt in das Textfeld ein (empfohlen, Aktion, Beleuchtung und physikalische Zustandsbeschreibungen einzubeziehen) oder laden Sie ein Referenzbild hoch, um die Funktion "Bild zu Video" zu verwenden.',
        step4Title: 'Einstellungen anpassen und generieren',
        step4Description: 'Legen Sie das Video-Seitenverhältnis (z. B. 16:9) und die Dauer (unterstützt 5s oder 10s) fest und klicken Sie dann auf "Jetzt generieren", um hochauflösendes Video zu erhalten.',

        // YouTube-Abschnitt
        youtubeTitle: 'YouTube-Videos',

        // X-Beiträge Abschnitt
        xPostsTitle: 'X-Beiträge',

        // Weitere Modelle
        exploreModelsTitle: 'Weitere Videomodelle auf 微鲤AI erkunden',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ
        faqTitle: 'Häufige Fragen',
        faq1Question: 'Was ist Runway Gen-4.5?',
        faq1Answer: 'Es ist Runways neuestes Flaggschiff-Text-zu-Video-Modell, bekannt für seine hervorragenden Physiksimulationsfähigkeiten und Bildstabilität und belegt derzeit den ersten Platz in Branchen-Benchmark-Tests.',
        faq2Question: 'Was ist der Unterschied zu Gen-4?',
        faq2Answer: 'Gen-4.5 führt die A2D-Hybridarchitektur ein. Im Vergleich zu Gen-4 weist es erhebliche Verbesserungen bei der physikalischen Realität der Objektbewegung (wie Schwerkraft und Trägheit), der zeitlichen Konsistenz der Bilder und dem Verständnis komplexer Prompts auf.',
        faq3Question: 'Wie lang ist die Videodauer?',
        faq3Answer: 'Derzeit unterstützt Gen-4.5 die Generierung hochauflösender Videoclips von bis zu 10 Sekunden, was sehr gut für die Erstellung von Kurzvideos, Werbespots oder Film-Previsualisierung (Previs) geeignet ist.',
        faq4Question: 'Muss ich bezahlen, um es auf 微鲤AI zu verwenden?',
        faq4Answer: '微鲤AI bietet neuen Benutzern kostenlose Testguthaben. Da Gen-4.5 höhere Rechenkosten hat, verbraucht es etwas mehr Guthaben als ältere Modelle. Es wird empfohlen, auf die Pro-Mitgliedschaft zu upgraden, um mehr Generierungszeiten zu erhalten.',
        faq5Question: 'Unterstützt es "Bild zu Video"?',
        faq5Answer: 'Ja. Die Bild-zu-Video-Funktion von Gen-4.5 ist sehr leistungsstark und kann den Stil und die Charaktereigenschaften des Referenzbildes perfekt bewahren und sie sich natürlich bewegen lassen.',
        faq6Question: 'Für welche Arten von Projekten ist es geeignet?',
        faq6Answer: 'Sehr geeignet für kommerzielle Werbung, die kinematografische Qualität anstrebt, visuelle Effekte (VFX) Previsualisierung, komplexe physikalische Dynamik-Displays (wie Flüssigkeiten und Explosionen) und narrative Kurzfilmkreation.',

        // CTA
        ctaTitle: 'Erleben Sie Runway Gen-4.5 jetzt',
        ctaDescription: 'Probieren Sie Runway Gen-4.5 kostenlos auf 微鲤AI aus und erstellen Sie KI-Videos jenseits der Vorstellungskraft',
        ctaButton: 'Mit dem Erstellen beginnen',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich · Kostenlose Testversion für neue Benutzer',
    },
    ru: {
        // Раздел генератора
        generatorTitle: 'Генератор видео Runway Gen-4.5 на базе ИИ',
        generatorDescription: 'Runway Gen-4.5 — это новейшая флагманская модель генерации видео на базе ИИ, выпущенная Runway в декабре 2025 года, представляющая "новый рубеж" технологии генеративного видео. Как крупное обновление серии Gen-4, эта модель представляет революционную гибридную архитектуру "Авторегрессия-к-Диффузии (A2D)", которая полностью решает проблемы предыдущих моделей в симуляции физических законов и долгосрочной временной согласованности. Она не только занимает первое место в видео-арене Artificial Analysis с оценкой Elo 1247, но и становится первым выбором для профессиональных создателей благодаря точному восстановлению динамики жидкостей, обнаружению гравитации и сложного освещения. Приходите на 微鲤AI, чтобы бесплатно испытать Runway Gen-4.5 и почувствовать творческую силу изображений за пределами реальности!',
        
        // Вкладки
        tabImageToVideo: 'Изображение в видео',

        // Основные функции
        coreFeaturesTitle: 'Основные функции Runway Gen-4.5',
        coreFeaturesSubtitle: 'Глубоко погрузитесь в физический движок и гибридную архитектуру генератора видео Runway Gen-4.5, испытайте точное и контролируемое кинематографическое творчество.',

        // Функция 1: Движок симуляции физических законов
        feature1Title: 'Движок симуляции физических законов',
        feature1Description: 'Самое значительное улучшение Gen-4.5 заключается в его глубоком понимании физических законов реального мира. Он может точно моделировать вес объектов, импульс, столкновения и сложные эффекты динамики жидкостей, полностью устраняя распространенное ощущение "плавания" и контр-интуитивное движение в видео с ИИ.',

        // Функция 2: Гибридная архитектура авторегрессии-к-диффузии
        feature2Title: 'Гибридная архитектура авторегрессии-к-диффузии',
        feature2Description: 'Объединяет способность понимания сцен авторегрессивных моделей с визуальной высокой точностью моделей диффузии. Эта гибридная технология гарантирует, что персонажи и объекты сохраняют структурную целостность даже во время быстрого движения или окклюзии, без деформации или исчезновения.',

        // Функция 3: Сильное следование промпту
        feature3Title: 'Сильное следование промпту',
        feature3Description: 'Выполнение сложных промптов моделью достигло новых высот, точно восстанавливая каждую деталь, описанную пользователями, включая композицию, стиль освещения и отношения взаимодействия между несколькими субъектами, достигая "что вы думаете, то и получаете".',

        // Функция 4: Временная согласованность микро-деталей
        feature4Title: 'Временная согласованность микро-деталей',
        feature4Description: 'Фокусируется на поддержании стабильности крошечных деталей во временных измерениях. Будь то трепет волос, рябь на воде или текстура кожи, все остается согласованным на протяжении всего видеосегмента, устраняя распространенное явление "мерцания" в традиционных моделях.',

        // Раздел как использовать
        howToUseTitle: 'Как использовать на 微鲤AI',
        step1Title: 'Войти в рабочее пространство',
        step1Description: 'Войдите в рабочее пространство создания 微鲤AI и нажмите на библиотеку "Видеомодели" в левой панели навигации.',
        step2Title: 'Выбрать модель',
        step2Description: 'Найдите и выберите Runway Gen-4.5 (помечено как New) в списке моделей.',
        step3Title: 'Ввести описание',
        step3Description: 'Введите ваш подробный промпт в текстовое поле (рекомендуется включить описания действия, освещения и физического состояния) или загрузите эталонное изображение для использования функции "Изображение в видео".',
        step4Title: 'Настроить параметры и сгенерировать',
        step4Description: 'Установите соотношение сторон видео (например, 16:9) и длительность (поддерживает 5с или 10с), затем нажмите "Сгенерировать сейчас", чтобы получить видео высокой четкости.',

        // Раздел YouTube
        youtubeTitle: 'Видео на YouTube',

        // Раздел публикации в X
        xPostsTitle: 'Публикации в X',

        // Исследовать другие модели
        exploreModelsTitle: 'Исследуйте другие видеомодели на 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Runway Gen-4.5?',
        faq1Answer: 'Это новейшая флагманская модель текст-в-видео от Runway, известная своими превосходными возможностями симуляции физики и стабильностью изображения, в настоящее время занимающая первое место в отраслевых тестах.',
        faq2Question: 'В чем разница с Gen-4?',
        faq2Answer: 'Gen-4.5 вводит гибридную архитектуру A2D. По сравнению с Gen-4, он имеет значительные улучшения в физическом реализме движения объектов (таких как гравитация и инерция), временной согласованности изображений и понимании сложных промптов.',
        faq3Question: 'Какова длительность видео?',
        faq3Answer: 'В настоящее время Gen-4.5 поддерживает генерацию видеоклипов высокой четкости до 10 секунд, что очень подходит для создания коротких видео, рекламных кадров или предварительной визуализации фильма (Previs).',
        faq4Question: 'Нужно ли платить за использование на 微鲤AI?',
        faq4Answer: '微鲤AI предоставляет бесплатные пробные кредиты для новых пользователей. Поскольку Gen-4.5 имеет более высокие вычислительные затраты, он потребляет немного больше кредитов, чем старые модели. Рекомендуется обновить до членства Pro, чтобы получить больше времени генерации.',
        faq5Question: 'Поддерживает ли он "Изображение в видео"?',
        faq5Answer: 'Да. Функция изображения в видео Gen-4.5 очень мощная, способная идеально сохранить стиль и характеристики персонажа эталонного изображения и заставить их двигаться естественно.',
        faq6Question: 'Для каких типов проектов он подходит?',
        faq6Answer: 'Очень подходит для коммерческой рекламы, стремящейся к кинематографическому качеству, предварительной визуализации визуальных эффектов (VFX), сложных дисплеев физической динамики (таких как жидкости и взрывы) и создания повествовательных короткометражных фильмов.',

        // CTA
        ctaTitle: 'Испытайте Runway Gen-4.5 сейчас',
        ctaDescription: 'Попробуйте Runway Gen-4.5 бесплатно на 微鲤AI и создавайте видео с ИИ за пределами воображения',
        ctaButton: 'Начать создавать',
        ctaDisclaimer: 'Кредитная карта не требуется · Бесплатная пробная версия для новых пользователей',
    },
    pt: {
        // Seção do gerador
        generatorTitle: 'Gerador de vídeos com IA Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 é o último modelo de geração de vídeos com IA lançado pela Runway em dezembro de 2025, representando a "nova fronteira" da tecnologia de vídeo generativo. Como uma atualização importante da série Gen-4, este modelo introduz uma arquitetura híbrida inovadora "Autoregressivo para Difusão (A2D)" que resolve completamente os pontos fracos dos modelos anteriores na simulação de leis físicas e consistência temporal de longo prazo. Ele não apenas ocupa o primeiro lugar na arena de vídeos da Artificial Analysis com uma pontuação Elo de 1247, mas também se torna a primeira escolha para criadores profissionais devido à sua restauração precisa de dinâmica de fluidos, detecção de gravidade e iluminação complexa. Venha para o 微鲤AI experimentar o Runway Gen-4.5 gratuitamente e sinta o poder criativo de imagens além da realidade!',
        
        // Abas
        tabImageToVideo: 'Imagem para vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos principais do Runway Gen-4.5',
        coreFeaturesSubtitle: 'Mergulhe profundamente no motor de física e na arquitetura híbrida do gerador de vídeos Runway Gen-4.5, experimente a criação cinematográfica precisa e controlável.',

        // Recurso 1: Motor de simulação de leis físicas
        feature1Title: 'Motor de simulação de leis físicas',
        feature1Description: 'A melhoria mais significativa do Gen-4.5 está em sua compreensão profunda das leis físicas do mundo real. Ele pode simular com precisão o peso dos objetos, momento, colisões e efeitos complexos de dinâmica de fluidos, eliminando completamente a sensação comum de "flutuação" e movimento contraintuitivo em vídeos com IA.',

        // Recurso 2: Arquitetura híbrida autoregressiva-difusão
        feature2Title: 'Arquitetura híbrida autoregressiva-difusão',
        feature2Description: 'Combina a capacidade de compreensão de cenas dos modelos autoregressivos com a alta fidelidade visual dos modelos de difusão. Esta tecnologia híbrida garante que personagens e objetos mantenham a integridade estrutural mesmo durante movimentos rápidos ou oclusão, sem deformação ou desaparecimento.',

        // Recurso 3: Forte aderência ao prompt
        feature3Title: 'Forte aderência ao prompt',
        feature3Description: 'A execução de prompts complexos pelo modelo atingiu novas alturas, restaurando com precisão cada detalhe descrito pelos usuários, incluindo composição, estilo de iluminação e relações de interação entre múltiplos sujeitos, alcançando "o que você pensa é o que você obtém".',

        // Recurso 4: Consistência temporal de micro-detalhes
        feature4Title: 'Consistência temporal de micro-detalhes',
        feature4Description: 'Foca em manter a estabilidade de detalhes minúsculos através das dimensões temporais. Seja o movimento do cabelo, ondulações na água ou a textura da pele, tudo permanece coerente ao longo do segmento de vídeo, eliminando o fenômeno comum de "piscar" em modelos tradicionais.',

        // Seção de como usar
        howToUseTitle: 'Como usar no 微鲤AI',
        step1Title: 'Fazer login no espaço de trabalho',
        step1Description: 'Entre no espaço de trabalho de criação do 微鲤AI e clique na biblioteca "Modelos de vídeo" na barra de navegação esquerda.',
        step2Title: 'Selecionar modelo',
        step2Description: 'Encontre e selecione Runway Gen-4.5 (marcado como New) na lista de modelos.',
        step3Title: 'Inserir descrição',
        step3Description: 'Digite seu prompt detalhado na caixa de texto (recomendado incluir descrições de ação, iluminação e estado físico) ou carregue uma imagem de referência para usar a função "Imagem para vídeo".',
        step4Title: 'Ajustar configurações e gerar',
        step4Description: 'Defina a proporção do vídeo (como 16:9) e a duração (suporta 5s ou 10s), depois clique em "Gerar agora" para obter vídeo de alta definição.',

        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube',

        // Seção de publicações no X
        xPostsTitle: 'Publicações no X',

        // Seção de explorar outros modelos
        exploreModelsTitle: 'Explore outros modelos de vídeo no 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // Seção de perguntas frequentes
        faqTitle: 'Perguntas frequentes',
        faq1Question: 'O que é Runway Gen-4.5?',
        faq1Answer: 'É o último modelo de texto para vídeo lançado pela Runway, conhecido por suas excelentes capacidades de simulação física e estabilidade de imagem, atualmente ocupando o primeiro lugar nos testes de referência da indústria.',
        faq2Question: 'Qual é a diferença com o Gen-4?',
        faq2Answer: 'Gen-4.5 introduz a arquitetura híbrida A2D. Comparado ao Gen-4, tem melhorias significativas no realismo físico do movimento de objetos (como gravidade e inércia), consistência temporal das imagens e compreensão de prompts complexos.',
        faq3Question: 'Qual é a duração do vídeo?',
        faq3Answer: 'Atualmente, Gen-4.5 suporta a geração de clipes de vídeo de alta definição de até 10 segundos, muito adequado para criar vídeos curtos, tomadas publicitárias ou pré-visualização cinematográfica (Previs).',
        faq4Question: 'Preciso pagar para usá-lo no 微鲤AI?',
        faq4Answer: '微鲤AI fornece créditos de teste gratuitos para novos usuários. Como Gen-4.5 tem custos de computação mais altos, consome um pouco mais de créditos do que os modelos mais antigos. Recomenda-se atualizar para a assinatura Pro para obter mais vezes de geração.',
        faq5Question: 'Ele suporta "Imagem para vídeo"?',
        faq5Answer: 'Sim. A função de imagem para vídeo do Gen-4.5 é muito poderosa, capaz de preservar perfeitamente o estilo e as características do personagem da imagem de referência e fazê-los se mover naturalmente.',
        faq6Question: 'Para quais tipos de projetos é adequado?',
        faq6Answer: 'Muito adequado para anúncios comerciais que buscam qualidade cinematográfica, pré-visualização de efeitos visuais (VFX), exibições de dinâmica física complexa (como fluidos e explosões) e criação de curtas-metragens narrativos.',

        // Seção CTA
        ctaTitle: 'Experimente o Runway Gen-4.5 agora',
        ctaDescription: 'Experimente o Runway Gen-4.5 gratuitamente no 微鲤AI e crie vídeos com IA além da imaginação',
        ctaButton: 'Começar a criar',
        ctaDisclaimer: 'Não é necessário cartão de crédito · Teste gratuito para novos usuários',
    },
    it: {
        // Sezione del generatore
        generatorTitle: 'Generatore video IA Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 è l\'ultimo modello di punta per la generazione di video con IA lanciato da Runway nel dicembre 2025, rappresentando la "nuova frontiera" della tecnologia video generativa. Come aggiornamento importante della serie Gen-4, questo modello introduce un\'architettura ibrida rivoluzionaria "Autoregressivo-a-Diffusione (A2D)" che risolve completamente i punti deboli dei modelli precedenti nella simulazione delle leggi fisiche e nella coerenza temporale a lungo termine. Non solo occupa il primo posto nell\'arena video di Artificial Analysis con un punteggio Elo di 1247, ma diventa anche la prima scelta per i creatori professionisti grazie al suo ripristino preciso della dinamica dei fluidi, del rilevamento della gravità e dell\'illuminazione complessa. Vieni su 微鲤AI per sperimentare Runway Gen-4.5 gratuitamente e senti il potere creativo delle immagini oltre la realtà!',
        
        // Schede
        tabImageToVideo: 'Immagine in video',

        // Funzioni principali
        coreFeaturesTitle: 'Funzioni principali di Runway Gen-4.5',
        coreFeaturesSubtitle: 'Immergiti profondamente nel motore fisico e nell\'architettura ibrida del generatore video Runway Gen-4.5, sperimenta la creazione cinematografica precisa e controllabile.',

        // Funzione 1: Motore di simulazione delle leggi fisiche
        feature1Title: 'Motore di simulazione delle leggi fisiche',
        feature1Description: 'Il miglioramento più significativo di Gen-4.5 risiede nella sua profonda comprensione delle leggi fisiche del mondo reale. Può simulare con precisione il peso degli oggetti, la quantità di moto, le collisioni e gli effetti complessi della dinamica dei fluidi, eliminando completamente la sensazione comune di "galleggiamento" e il movimento controintuitivo nei video con IA.',

        // Funzione 2: Architettura ibrida autoregressiva-diffusione
        feature2Title: 'Architettura ibrida autoregressiva-diffusione',
        feature2Description: 'Combina la capacità di comprensione delle scene dei modelli autoregressivi con l\'alta fedeltà visiva dei modelli di diffusione. Questa tecnologia ibrida garantisce che personaggi e oggetti mantengano l\'integrità strutturale anche durante movimenti rapidi o occlusione, senza deformazione o scomparsa.',

        // Funzione 3: Forte aderenza al prompt
        feature3Title: 'Forte aderenza al prompt',
        feature3Description: 'L\'esecuzione di prompt complessi da parte del modello ha raggiunto nuove vette, ripristinando con precisione ogni dettaglio descritto dagli utenti, inclusa composizione, stile di illuminazione e relazioni di interazione tra più soggetti, raggiungendo "quello che pensi è quello che ottieni".',

        // Funzione 4: Coerenza temporale dei micro-dettagli
        feature4Title: 'Coerenza temporale dei micro-dettagli',
        feature4Description: 'Si concentra sul mantenimento della stabilità di dettagli minuscoli attraverso le dimensioni temporali. Che si tratti del movimento dei capelli, delle increspature sull\'acqua o della texture della pelle, tutto rimane coerente per tutto il segmento video, eliminando il fenomeno comune di "sfarfallio" nei modelli tradizionali.',

        // Sezione come usare
        howToUseTitle: 'Come usarlo su 微鲤AI',
        step1Title: 'Accedere all\'area di lavoro',
        step1Description: 'Entra nell\'area di lavoro di creazione 微鲤AI e fai clic sulla libreria "Modelli video" nella barra di navigazione sinistra.',
        step2Title: 'Selezionare il modello',
        step2Description: 'Trova e seleziona Runway Gen-4.5 (contrassegnato come New) nell\'elenco dei modelli.',
        step3Title: 'Inserire la descrizione',
        step3Description: 'Inserisci il tuo prompt dettagliato nella casella di testo (si consiglia di includere descrizioni di azione, illuminazione e stato fisico) o carica un\'immagine di riferimento per utilizzare la funzione "Immagine in video".',
        step4Title: 'Regolare le impostazioni e generare',
        step4Description: 'Imposta le proporzioni del video (come 16:9) e la durata (supporta 5s o 10s), quindi fai clic su "Genera ora" per ottenere video ad alta definizione.',

        // Sezione video YouTube
        youtubeTitle: 'Video YouTube',

        // Sezione post su X
        xPostsTitle: 'Post su X',

        // Sezione esplorare altri modelli
        exploreModelsTitle: 'Esplora altri modelli video su 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // Sezione FAQ
        faqTitle: 'Domande frequenti',
        faq1Question: 'Cos\'è Runway Gen-4.5?',
        faq1Answer: 'È l\'ultimo modello di punta testo-video lanciato da Runway, noto per le sue eccellenti capacità di simulazione fisica e stabilità dell\'immagine, attualmente al primo posto nei test di riferimento del settore.',
        faq2Question: 'Qual è la differenza con Gen-4?',
        faq2Answer: 'Gen-4.5 introduce l\'architettura ibrida A2D. Rispetto a Gen-4, presenta miglioramenti significativi nel realismo fisico del movimento degli oggetti (come gravità e inerzia), coerenza temporale delle immagini e comprensione di prompt complessi.',
        faq3Question: 'Qual è la durata del video?',
        faq3Answer: 'Attualmente, Gen-4.5 supporta la generazione di clip video ad alta definizione fino a 10 secondi, molto adatto per creare video brevi, riprese pubblicitarie o previsualizzazione cinematografica (Previs).',
        faq4Question: 'Devo pagare per usarlo su 微鲤AI?',
        faq4Answer: '微鲤AI fornisce crediti di prova gratuiti per i nuovi utenti. Poiché Gen-4.5 ha costi di calcolo più elevati, consuma leggermente più crediti rispetto ai modelli più vecchi. Si consiglia di aggiornare all\'abbonamento Pro per ottenere più volte di generazione.',
        faq5Question: 'Supporta "Immagine in video"?',
        faq5Answer: 'Sì. La funzione immagine in video di Gen-4.5 è molto potente, in grado di preservare perfettamente lo stile e le caratteristiche del personaggio dell\'immagine di riferimento e farli muovere naturalmente.',
        faq6Question: 'Per quali tipi di progetti è adatto?',
        faq6Answer: 'Molto adatto per pubblicità commerciali che cercano qualità cinematografica, previsualizzazione di effetti visivi (VFX), display di dinamica fisica complessa (come fluidi ed esplosioni) e creazione di cortometraggi narrativi.',

        // Sezione CTA
        ctaTitle: 'Sperimenta Runway Gen-4.5 ora',
        ctaDescription: 'Prova Runway Gen-4.5 gratuitamente su 微鲤AI e crea video con IA oltre l\'immaginazione',
        ctaButton: 'Inizia a creare',
        ctaDisclaimer: 'Nessuna carta di credito richiesta · Prova gratuita per nuovi utenti',
    },
    ar: {
        // قسم المولد
        generatorTitle: 'مولد الفيديو بالذكاء الاصطناعي Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 هو أحدث نموذج رائد لتوليد الفيديو بالذكاء الاصطناعي أطلقته Runway في ديسمبر 2025، ويمثل "الحدود الجديدة" لتكنولوجيا الفيديو التوليدي. كتحديث رئيسي لسلسلة Gen-4، يقدم هذا النموذج بنية هجينة ثورية "من الانحدار الذاتي إلى الانتشار (A2D)" التي تحل تمامًا نقاط الضعف في النماذج السابقة في محاكاة القوانين الفيزيائية والاتساق الزمني طويل المدى. لا يحتل المرتبة الأولى في ساحة الفيديو لـ Artificial Analysis بدرجة Elo 1247 فحسب، بل يصبح أيضًا الخيار الأول للمبدعين المحترفين بسبب استعادته الدقيقة لديناميكيات السوائل واكتشاف الجاذبية والإضاءة المعقدة. تعال إلى 微鲤AI لتجربة Runway Gen-4.5 مجانًا وشعر بقوة الصور الإبداعية التي تتجاوز الواقع!',
        
        // علامات التبويب
        tabImageToVideo: 'تحويل صورة إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الأساسية لـ Runway Gen-4.5',
        coreFeaturesSubtitle: 'اغمر نفسك بعمق في محرك الفيزياء والبنية الهجينة لمولد الفيديو Runway Gen-4.5، واختبر الإبداع السينمائي الدقيق والقابل للتحكم.',

        // الميزة 1: محرك محاكاة القوانين الفيزيائية
        feature1Title: 'محرك محاكاة القوانين الفيزيائية',
        feature1Description: 'التحسين الأكثر أهمية في Gen-4.5 يكمن في فهمه العميق لقوانين الفيزياء في العالم الحقيقي. يمكنه محاكاة وزن الكائنات والزخم والاصطدامات وتأثيرات ديناميكيات السوائل المعقدة بدقة، مما يزيل تمامًا الإحساس الشائع بـ"الطفو" والحركة المضادة للحدس في مقاطع الفيديو بالذكاء الاصطناعي.',

        // الميزة 2: البنية الهجينة من الانحدار الذاتي إلى الانتشار
        feature2Title: 'البنية الهجينة من الانحدار الذاتي إلى الانتشار',
        feature2Description: 'يجمع بين قدرة فهم المشهد للنماذج الانحدارية الذاتية والدقة البصرية العالية لنماذج الانتشار. تضمن هذه التقنية الهجينة أن الشخصيات والكائنات تحافظ على السلامة الهيكلية حتى أثناء الحركة السريعة أو الانسداد، دون تشوه أو اختفاء.',

        // الميزة 3: الالتزام القوي بالمطالبة
        feature3Title: 'الالتزام القوي بالمطالبة',
        feature3Description: 'وصل تنفيذ المطالبات المعقدة بواسطة النموذج إلى آفاق جديدة، مستعيدًا بدقة كل تفصيل وصفه المستخدمون، بما في ذلك التكوين وأسلوب الإضاءة وعلاقات التفاعل بين عدة مواضيع، محققًا "ما تفكر فيه هو ما تحصل عليه".',

        // الميزة 4: اتساق التفاصيل الدقيقة الزمني
        feature4Title: 'اتساق التفاصيل الدقيقة الزمني',
        feature4Description: 'يركز على الحفاظ على استقرار التفاصيل الصغيرة عبر الأبعاد الزمنية. سواء كان ذلك حركة الشعر أو التموجات على الماء أو نسيج الجلد، يبقى كل شيء متماسكًا طوال مقطع الفيديو، مما يزيل ظاهرة "الوميض" الشائعة في النماذج التقليدية.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام على 微鲤AI',
        step1Title: 'تسجيل الدخول إلى مساحة العمل',
        step1Description: 'ادخل إلى مساحة عمل الإبداع في 微鲤AI وانقر على مكتبة "نماذج الفيديو" في شريط التنقل الأيسر.',
        step2Title: 'اختيار النموذج',
        step2Description: 'ابحث واختر Runway Gen-4.5 (مميز كـ New) في قائمة النماذج.',
        step3Title: 'إدخال الوصف',
        step3Description: 'أدخل مطالبتك التفصيلية في مربع النص (يُنصح بتضمين أوصاف الإجراء والإضاءة والحالة الفيزيائية) أو ارفع صورة مرجعية لاستخدام وظيفة "تحويل صورة إلى فيديو".',
        step4Title: 'ضبط الإعدادات والتوليد',
        step4Description: 'قم بتعيين نسبة العرض إلى الارتفاع للفيديو (مثل 16:9) والمدة (يدعم 5 ثوانٍ أو 10 ثوانٍ)، ثم انقر على "توليد الآن" للحصول على فيديو عالي الدقة.',

        // قسم مقاطع YouTube
        youtubeTitle: 'مقاطع YouTube',

        // قسم منشورات X
        xPostsTitle: 'منشورات X',

        // استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج فيديو أخرى على 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Runway Gen-4.5؟',
        faq1Answer: 'هو أحدث نموذج رائد من نص إلى فيديو أطلقته Runway، معروف بقدراته الممتازة في محاكاة الفيزياء واستقرار الصورة، ويحتل حاليًا المرتبة الأولى في اختبارات معايير الصناعة.',
        faq2Question: 'ما الفرق مع Gen-4؟',
        faq2Answer: 'Gen-4.5 يقدم البنية الهجينة A2D. مقارنة بـ Gen-4، لديه تحسينات كبيرة في الواقعية الفيزيائية لحركة الكائنات (مثل الجاذبية والقصور الذاتي)، واتساق الصور الزمني، وفهم المطالبات المعقدة.',
        faq3Question: 'ما هي مدة الفيديو؟',
        faq3Answer: 'حاليًا، يدعم Gen-4.5 توليد مقاطع فيديو عالية الدقة تصل إلى 10 ثوانٍ، وهي مناسبة جدًا لإنشاء مقاطع فيديو قصيرة أو لقطات إعلانية أو معاينة سينمائية (Previs).',
        faq4Question: 'هل أحتاج إلى الدفع لاستخدامه على 微鲤AI؟',
        faq4Answer: 'يوفر 微鲤AI رصيد تجريبي مجاني للمستخدمين الجدد. نظرًا لأن Gen-4.5 لديه تكاليف حسابية أعلى، فإنه يستهلك رصيدًا أكثر قليلاً من النماذج الأقدم. يُنصح بالترقية إلى عضوية Pro للحصول على المزيد من أوقات التوليد.',
        faq5Question: 'هل يدعم "تحويل صورة إلى فيديو"؟',
        faq5Answer: 'نعم. وظيفة تحويل الصورة إلى فيديو في Gen-4.5 قوية جدًا، قادرة على الحفاظ بشكل مثالي على أسلوب وخصائص الشخصية في الصورة المرجعية وجعلها تتحرك بشكل طبيعي.',
        faq6Question: 'ما أنواع المشاريع المناسبة له؟',
        faq6Answer: 'مناسب جدًا للإعلانات التجارية التي تسعى للحصول على جودة سينمائية، ومعاينة التأثيرات البصرية (VFX)، وعروض الديناميكيات الفيزيائية المعقدة (مثل السوائل والانفجارات)، وإنشاء أفلام قصيرة سردية.',

        // قسم دعوة لاتخاذ إجراء
        ctaTitle: 'جرب Runway Gen-4.5 الآن',
        ctaDescription: 'جرب Runway Gen-4.5 مجانًا على 微鲤AI وأنشئ مقاطع فيديو بالذكاء الاصطناعي تتجاوز الخيال',
        ctaButton: 'ابدأ الإبداع',
        ctaDisclaimer: 'لا حاجة إلى بطاقة ائتمان · تجربة مجانية للمستخدمين الجدد',
        },
    th: {
        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ AI Runway Gen-4.5',
        generatorDescription: 'Runway Gen-4.5 คือโมเดลสร้างวิดีโอ AI เรือธงรุ่นล่าสุดของ Runway เปิดตัวในเดือนธันวาคม 2025 และถูกยกให้เป็น “แนวหน้าใหม่” ของเทคโนโลยีวิดีโอเชิงกำเนิด ในฐานะอัปเกรดใหญ่ของซีรีส์ Gen-4 โมเดลนี้ใช้สถาปัตยกรรมไฮบริด “Autoregressive-to-Diffusion (A2D)” ช่วยแก้ปัญหาการจำลองฟิสิกส์และความสม่ำเสมอระยะยาวของรุ่นก่อนหน้าอย่างสิ้นเชิง ไม่เพียงครองอันดับ 1 ในวิดีโออารีนาของ Artificial Analysis ด้วยคะแนน Elo 1247 แต่ยังเป็นตัวเลือกอันดับต้นๆ ของครีเอเตอร์มืออาชีพจากความสามารถในการถ่ายทอดไดนามิกของของไหล แรงโน้มถ่วง และแสงเงาซับซ้อนได้อย่างแม่นยำ มาลอง Runway Gen-4.5 ฟรีบน 微鲤AI แล้วสัมผัสพลังสร้างสรรค์ที่เหนือความจริง!',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Runway Gen-4.5',
        coreFeaturesSubtitle: 'เจาะลึกเอนจินฟิสิกส์และสถาปัตยกรรมไฮบริดของ Runway Gen-4.5 เพื่อการสร้างสรรค์ระดับภาพยนตร์ที่แม่นยำและควบคุมได้',

        // Feature 1: Physics simulation engine
        feature1Title: 'เอนจินจำลองกฎฟิสิกส์',
        feature1Description: 'จุดเด่นที่สุดของ Gen-4.5 คือความเข้าใจเชิงลึกต่อกฎฟิสิกส์โลกจริง สามารถจำลองน้ำหนัก โมเมนตัม การชน และไดนามิกของของไหลได้อย่างแม่นยำ ลดอาการ “ลอย” และการเคลื่อนไหวที่ขัดสัญชาตญาณในวิดีโอ AI',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'สถาปัตยกรรมไฮบริด Autoregressive-to-Diffusion',
        feature2Description: 'ผสานการเข้าใจฉากของโมเดลออโตรีเกรสซีฟกับความคมชัดสูงของโมเดลดิฟฟิวชัน ทำให้ตัวละครและวัตถุคงโครงสร้างได้แม้เคลื่อนไหวเร็วหรือถูกบัง โดยไม่บิดเบี้ยวหรือหายไป',

        // Feature 3: Strong prompt adherence
        feature3Title: 'ยึดตามพรอมป์ต์อย่างแม่นยำ',
        feature3Description: 'โมเดลทำตามพรอมป์ต์ซับซ้อนได้อย่างยอดเยี่ยม คืนรายละเอียดทุกส่วนที่ผู้ใช้ระบุ ทั้งองค์ประกอบภาพ สไตล์แสง และความสัมพันธ์ของหลายตัวแบบ ให้ผลลัพธ์ “คิดอย่างไร ได้อย่างนั้น”',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'ความสม่ำเสมอของรายละเอียดจิ๋วตามเวลา',
        feature4Description: 'เน้นรักษาความเสถียรของรายละเอียดเล็กๆ ตลอดเวลา ไม่ว่าจะเป็นผมปลิว ระลอกน้ำ หรือพื้นผิวผิวหนัง ทุกอย่างคงความต่อเนื่องตลอดคลิป ลดอาการ “กระพริบ” ที่พบบ่อยในโมเดลเดิม',

        // How to use section
        howToUseTitle: 'วิธีใช้งานบน 微鲤AI',
        step1Title: 'เข้าสู่เวิร์กสเปซ',
        step1Description: 'เข้า 微鲤AI Workspace แล้วคลิกคลัง “Video Models” ในแถบนำทางด้านซ้าย',
        step2Title: 'เลือกโมเดล',
        step2Description: 'ค้นหาและเลือก Runway Gen-4.5 (มีป้าย New) ในรายการโมเดล',
        step3Title: 'ใส่คำอธิบาย',
        step3Description: 'พิมพ์พรอมป์ต์อย่างละเอียด (แนะนำให้ระบุการเคลื่อนไหว แสง และสถานะทางฟิสิกส์) หรืออัปโหลดภาพอ้างอิงเพื่อใช้ฟีเจอร์ “ภาพเป็นวิดีโอ”',
        step4Title: 'ตั้งค่าและสร้าง',
        step4Description: 'ตั้งอัตราส่วนวิดีโอ (เช่น 16:9) และความยาว (รองรับ 5s หรือ 10s) แล้วคลิก “สร้างทันที” เพื่อรับวิดีโอความละเอียดสูง',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube',

        // X Posts section
        xPostsTitle: 'โพสต์บน X',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลวิดีโออื่นๆ บน 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Runway Gen-4.5 คืออะไร?',
        faq1Answer: 'เป็นโมเดลข้อความเป็นวิดีโอเรือธงรุ่นล่าสุดของ Runway โดดเด่นเรื่องการจำลองฟิสิกส์และความเสถียรของภาพ ปัจจุบันครองอันดับ 1 ในการทดสอบมาตรฐานอุตสาหกรรม',
        faq2Question: 'ต่างจาก Gen-4 อย่างไร?',
        faq2Answer: 'Gen-4.5 นำสถาปัตยกรรมไฮบริด A2D มาใช้ ทำให้ความสมจริงทางฟิสิกส์ของการเคลื่อนไหว (เช่น แรงโน้มถ่วงและแรงเฉื่อย) ความสม่ำเสมอของภาพตามเวลา และการเข้าใจพรอมป์ต์ซับซ้อนดีขึ้นอย่างชัดเจน',
        faq3Question: 'วิดีโอยาวได้เท่าไร?',
        faq3Answer: 'ปัจจุบัน Gen-4.5 สร้างคลิป HD ได้ยาวสูงสุด 10 วินาที เหมาะกับคลิปสั้น ช็อตโฆษณา หรือการพรีวิชวลไลเซชัน (Previs)',
        faq4Question: 'ใช้บน 微鲤AI ต้องจ่ายไหม?',
        faq4Answer: '微鲤AI มีเครดิตทดลองฟรีสำหรับผู้ใช้ใหม่ เนื่องจาก Gen-4.5 ใช้ทรัพยากรมากกว่า โมเดลนี้จึงใช้เครดิตมากกว่ารุ่นเก่าเล็กน้อย แนะนำอัปเกรดเป็น Pro เพื่อสร้างได้มากขึ้น',
        faq5Question: 'รองรับ “ภาพเป็นวิดีโอ” ไหม?',
        faq5Answer: 'รองรับ ฟีเจอร์ภาพเป็นวิดีโอของ Gen-4.5 แข็งแรงมาก รักษาสไตล์และลักษณะตัวละครจากภาพอ้างอิงได้อย่างดี และทำให้เคลื่อนไหวอย่างเป็นธรรมชาติ',
        faq6Question: 'เหมาะกับงานแบบไหน?',
        faq6Answer: 'เหมาะมากสำหรับโฆษณาคุณภาพระดับภาพยนตร์ งานพรีวิชวลไลเซชัน VFX การแสดงไดนามิกฟิสิกส์ซับซ้อน (เช่น ของไหลและการระเบิด) และหนังสั้นเชิงเล่าเรื่อง',

        // CTA section
        ctaTitle: 'ลอง Runway Gen-4.5 ตอนนี้',
        ctaDescription: 'ทดลอง Runway Gen-4.5 ฟรีบน 微鲤AI แล้วสร้างวิดีโอ AI ที่เหนือจินตนาการ',
        ctaButton: 'เริ่มสร้าง',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต · ทดลองฟรีสำหรับผู้ใช้ใหม่',
        },
    da: {
        // Generator section
        generatorTitle: 'Runway Gen-4.5 AI-videogenerator',
        generatorDescription: 'Runway Gen-4.5 er Runways nyeste flagskibsmodel til AI‑videogenerering, lanceret i december 2025, og markerer den “nye front” inden for generativ videoteknologi. Som en stor opgradering af Gen‑4-serien introducerer modellen en banebrydende Autoregressive‑to‑Diffusion (A2D) hybridarkitektur, der løser tidligere modellernes udfordringer med fysiksimulering og langvarig tidskonsistens. Den ligger ikke kun nr. 1 i Artificial Analysis’ videoarena med en Elo-score på 1247, men er også førstevalg for professionelle skabere takket være præcis gengivelse af væskedynamik, tyngdekraft og kompleks belysning. Prøv Runway Gen‑4.5 gratis på 微鲤AI og oplev kreativ kraft ud over virkeligheden!',
        
        // Tabs
        tabImageToVideo: 'Billede til video',

        // Core features section
        coreFeaturesTitle: 'Kernefunktioner i Runway Gen-4.5',
        coreFeaturesSubtitle: 'Dyk ned i Runway Gen-4.5‑videogeneratorens fysikmotor og hybridarkitektur, og oplev præcis og kontrollerbar filmisk skabelse.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Motor til simulering af fysiske love',
        feature1Description: 'Den største forbedring i Gen-4.5 er den dybe forståelse af fysiske love i den virkelige verden. Den kan præcist simulere objekters vægt, momentum, kollisioner og kompleks væskedynamik og fjerner den almindelige “svævefornemmelse” og kontraintuitive bevægelser i AI‑videoer.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Autoregressive-to-Diffusion hybridarkitektur',
        feature2Description: 'Kombinerer sceneforståelsen fra autoregressive modeller med den visuelle højfidelitet fra diffusionsmodeller. Denne hybridteknologi sikrer, at karakterer og objekter bevarer strukturel integritet selv ved hurtig bevægelse eller okklusion, uden deformation eller forsvinden.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Stærk prompt-efterlevelse',
        feature3Description: 'Modellen udfører komplekse prompter på et nyt niveau og genskaber præcist alle detaljer brugeren beskriver, inklusive komposition, lysstil og interaktioner mellem flere motiver – “det du tænker, er det du får”.',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Tidsmæssig konsistens i mikrodetaljer',
        feature4Description: 'Fokuserer på stabilitet i små detaljer over tid. Om det er hår, der blafrer, bølger i vandet eller hudtekstur, forbliver alt sammenhængende gennem hele klippet og eliminerer den almindelige “flimmer”-effekt.',

        // How to use section
        howToUseTitle: 'Sådan bruger du på 微鲤AI',
        step1Title: 'Log ind på workspace',
        step1Description: 'Gå ind i 微鲤AI-arbejdsområdet og klik på biblioteket “Video Models” i venstre navigation.',
        step2Title: 'Vælg model',
        step2Description: 'Find og vælg Runway Gen-4.5 (markeret som New) i modellisten.',
        step3Title: 'Indtast beskrivelse',
        step3Description: 'Indtast din detaljerede prompt (anbefalet: handling, belysning og fysisk tilstand), eller upload et referencebillede for at bruge “Billede til video”.',
        step4Title: 'Justér indstillinger og generér',
        step4Description: 'Indstil format (fx 16:9) og varighed (5s eller 10s), og klik derefter “Generér nu” for at få video i høj opløsning.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer',

        // X Posts section
        xPostsTitle: 'X-opslag',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre videomodeller på 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er Runway Gen-4.5?',
        faq1Answer: 'Det er Runways nyeste flagskibsmodel til text‑to‑video, kendt for fremragende fysiksimulering og billedstabilitet, og ligger pt. nr. 1 i branchens benchmark-tests.',
        faq2Question: 'Hvad er forskellen på den og Gen-4?',
        faq2Answer: 'Gen-4.5 introducerer A2D‑hybridarkitekturen. Sammenlignet med Gen‑4 giver den markante forbedringer i fysisk realisme af objektbevægelse (fx tyngdekraft og inerti), tidskonsistens i billeder og forståelse af komplekse prompter.',
        faq3Question: 'Hvor lang er videoen?',
        faq3Answer: 'Gen-4.5 understøtter i øjeblikket HD‑klip op til 10 sekunder, hvilket er ideelt til korte videoer, reklameshots eller film pre-visualization (Previs).',
        faq4Question: 'Skal jeg betale for at bruge den på 微鲤AI?',
        faq4Answer: '微鲤AI giver gratis prøvecredits til nye brugere. Da Gen-4.5 har højere beregningsomkostninger, bruger den lidt flere credits end ældre modeller. Det anbefales at opgradere til Pro for flere genereringer.',
        faq5Question: 'Understøtter den “Image to Video”?',
        faq5Answer: 'Ja. Gen-4.5’s image‑to‑video‑funktion er meget stærk, bevarer stil og karaktertræk i referencebilledet og får dem til at bevæge sig naturligt.',
        faq6Question: 'Hvilke projekter er den velegnet til?',
        faq6Answer: 'Meget velegnet til reklamer med filmisk kvalitet, VFX pre-visualization, komplekse fysiske dynamikker (som væsker og eksplosioner) og narrative kortfilm.',

        // CTA section
        ctaTitle: 'Oplev Runway Gen-4.5 nu',
        ctaDescription: 'Prøv Runway Gen-4.5 gratis på 微鲤AI og skab AI-videoer ud over fantasien',
        ctaButton: 'Kom i gang',
        ctaDisclaimer: 'Intet kreditkort kræves · Gratis prøveperiode for nye brugere',
        },
    no: {
        // Generator section
        generatorTitle: 'Runway Gen-4.5 AI-videogenerator',
        generatorDescription: 'Runway Gen-4.5 er Runways nyeste flaggskipmodell for AI‑videogenerering, lansert i desember 2025, og markerer den «nye fronten» innen generativ videoteknologi. Som en stor oppgradering av Gen‑4‑serien introduserer modellen en banebrytende Autoregressive‑to‑Diffusion (A2D) hybridarkitektur som løser tidligere modellers utfordringer med fysikksimulering og langvarig tidskonsistens. Den ligger ikke bare som nr. 1 i Artificial Analysis’ videoarena med en Elo‑score på 1247, men er også førstevalget for profesjonelle skapere takket være presis gjengivelse av væskedynamikk, tyngdekraft og kompleks belysning. Prøv Runway Gen‑4.5 gratis på 微鲤AI og opplev den kreative kraften som går utover virkeligheten!',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',

        // Core features section
        coreFeaturesTitle: 'Kjernefunksjoner i Runway Gen-4.5',
        coreFeaturesSubtitle: 'Dypdykk i Runway Gen-4.5‑videogeneratorens fysikkmotor og hybridarkitektur, og opplev presis og kontrollerbar filmatisk skapelse.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Motor for fysikksimulering',
        feature1Description: 'Den viktigste forbedringen i Gen-4.5 er den dype forståelsen av fysiske lover i den virkelige verden. Den kan nøyaktig simulere objekters vekt, momentum, kollisjoner og kompleks væskedynamikk, og fjerner den vanlige «svevefølelsen» og kontraintuitive bevegelser i AI‑videoer.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Autoregressive-to-Diffusion hybridarkitektur',
        feature2Description: 'Kombinerer sceneforståelsen til autoregressive modeller med den visuelle høyfideliteten til diffusionsmodeller. Denne hybridteknologien sørger for at karakterer og objekter beholder strukturell integritet selv ved rask bevegelse eller okklusjon, uten deformasjon eller forsvinning.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Sterk etterlevelse av prompt',
        feature3Description: 'Modellen utfører komplekse prompter på et nytt nivå og gjenskaper presist alle detaljer brukerne beskriver, inkludert komposisjon, lysstil og interaksjoner mellom flere motiver – «det du tenker er det du får».',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Tidsmessig konsistens i mikrodetailler',
        feature4Description: 'Fokuserer på å bevare stabiliteten i små detaljer over tid. Enten det er hår som flagrer, bølger i vannet eller hudtekstur, forblir alt sammenhengende gjennom hele klippet og den vanlige «flimmer»-effekten elimineres.',

        // How to use section
        howToUseTitle: 'Slik bruker du på 微鲤AI',
        step1Title: 'Logg inn i workspace',
        step1Description: 'Gå inn i 微鲤AI‑arbeidsområdet og klikk på biblioteket «Video Models» i venstre navigasjon.',
        step2Title: 'Velg modell',
        step2Description: 'Finn og velg Runway Gen-4.5 (merket New) i modellisten.',
        step3Title: 'Skriv inn beskrivelse',
        step3Description: 'Skriv inn en detaljert prompt (anbefalt: handling, lys og fysisk tilstand), eller last opp et referansebilde for å bruke «Bilde til video».',
        step4Title: 'Juster innstillinger og generer',
        step4Description: 'Sett format (f.eks. 16:9) og varighet (5s eller 10s), og klikk deretter «Generer nå» for å få video i høy oppløsning.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer',

        // X Posts section
        xPostsTitle: 'X-innlegg',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre videomodeller på 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er Runway Gen-4.5?',
        faq1Answer: 'Det er Runways nyeste flaggskipmodell for text‑to‑video, kjent for utmerkede fysikksimuleringsevner og bildestabilitet, og rangert først i bransjens benchmark‑tester.',
        faq2Question: 'Hva er forskjellen fra Gen-4?',
        faq2Answer: 'Gen-4.5 introduserer A2D‑hybridarkitekturen. Sammenlignet med Gen‑4 gir den store forbedringer i fysisk realisme i objektbevegelse (som tyngdekraft og treghet), tidskonsistens i bilder og forståelse av komplekse prompter.',
        faq3Question: 'Hvor lang er videoen?',
        faq3Answer: 'Gen-4.5 støtter per nå HD‑klipp opptil 10 sekunder, som er svært egnet for korte videoer, reklameshots eller film pre-visualization (Previs).',
        faq4Question: 'Må jeg betale for å bruke det på 微鲤AI?',
        faq4Answer: '微鲤AI tilbyr gratis prøvecredits til nye brukere. Siden Gen-4.5 har høyere beregningskostnader, bruker den litt flere credits enn eldre modeller. Det anbefales å oppgradere til Pro for flere genereringer.',
        faq5Question: 'Støtter den «Image to Video»?',
        faq5Answer: 'Ja. Gen-4.5s image‑to‑video‑funksjon er svært kraftig, bevarer stil og karaktertrekk i referansebildet og får dem til å bevege seg naturlig.',
        faq6Question: 'Hvilke prosjekter passer den for?',
        faq6Answer: 'Svært egnet for reklamer som krever filmatisk kvalitet, VFX pre-visualization, komplekse fysiske dynamikker (som væsker og eksplosjoner) og fortellende kortfilm.',

        // CTA section
        ctaTitle: 'Opplev Runway Gen-4.5 nå',
        ctaDescription: 'Prøv Runway Gen-4.5 gratis på 微鲤AI og skap AI-videoer utover fantasien',
        ctaButton: 'Kom i gang',
        ctaDisclaimer: 'Ingen kredittkort kreves · Gratis prøveperiode for nye brukere',
        },
    nl: {
        // Generator section
        generatorTitle: 'Runway Gen-4.5 AI-videogenerator',
        generatorDescription: 'Runway Gen-4.5 is het nieuwste vlaggenschipmodel voor AI‑videogeneratie van Runway, gelanceerd in december 2025, en markeert de “nieuwe grens” van generatieve videotechnologie. Als grote upgrade van de Gen‑4‑serie introduceert dit model de baanbrekende Autoregressive‑to‑Diffusion (A2D) hybride architectuur, die de zwakke punten van eerdere modellen in fysicasimulatie en langetermijn‑consistentie oplost. Het staat niet alleen op #1 in de video‑arena van Artificial Analysis met een Elo‑score van 1247, maar is ook de eerste keuze van professionals dankzij de precieze weergave van vloeistofdynamica, zwaartekracht en complexe belichting. Probeer Runway Gen‑4.5 gratis op 微鲤AI en ervaar creatieve kracht voorbij de realiteit!',
        
        // Tabs
        tabImageToVideo: 'Afbeelding naar video',

        // Core features section
        coreFeaturesTitle: 'Kernfuncties van Runway Gen-4.5',
        coreFeaturesSubtitle: 'Duik in de physics engine en hybride architectuur van de Runway Gen-4.5‑videogenerator en ervaar nauwkeurige, controleerbare filmische creatie.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Fysicasimulatie‑engine',
        feature1Description: 'De belangrijkste verbetering van Gen-4.5 is het diepe begrip van natuurkundige wetten in de echte wereld. Het kan gewicht, momentum, botsingen en complexe vloeistofdynamica nauwkeurig simuleren en elimineert het veelvoorkomende “zwevende gevoel” en contra‑intuïtieve bewegingen in AI‑video’s.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Hybride Autoregressive-to-Diffusion‑architectuur',
        feature2Description: 'Combineert scene‑begrip van autoregressieve modellen met de visuele hoge trouw van diffusie‑modellen. Deze hybride technologie zorgt ervoor dat personages en objecten structureel intact blijven, zelfs bij snelle beweging of occlusie, zonder vervorming of verdwijnen.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Sterke prompt‑naleving',
        feature3Description: 'De uitvoering van complexe prompts bereikt nieuwe hoogten en reconstrueert nauwkeurig elk detail dat gebruikers beschrijven, inclusief compositie, lichtstijl en interacties tussen meerdere onderwerpen — “wat je denkt, is wat je krijgt”.',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Tijdelijke consistentie van microdetails',
        feature4Description: 'Richt zich op stabiliteit van kleine details door de tijd. Of het nu gaat om wapperend haar, rimpels op water of huidtextuur, alles blijft coherent gedurende de hele clip en voorkomt het veelvoorkomende “flikkeren” in traditionele modellen.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het op 微鲤AI',
        step1Title: 'Log in op de workspace',
        step1Description: 'Ga naar de 微鲤AI‑werkruimte en klik op de bibliotheek “Video Models” in de linker navigatiebalk.',
        step2Title: 'Selecteer het model',
        step2Description: 'Zoek en selecteer Runway Gen-4.5 (gemarkeerd als New) in de modellenlijst.',
        step3Title: 'Voer je beschrijving in',
        step3Description: 'Voer je gedetailleerde prompt in (aanbevolen: actie, belichting en fysieke toestand) of upload een referentiebeeld om de functie “Afbeelding naar video” te gebruiken.',
        step4Title: 'Pas instellingen aan en genereer',
        step4Description: 'Stel de beeldverhouding (bijv. 16:9) en duur (5s of 10s) in en klik op “Nu genereren” om een HD‑video te krijgen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video’s',

        // X Posts section
        xPostsTitle: 'X-berichten',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere videomodellen op 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is Runway Gen-4.5?',
        faq1Answer: 'Het is Runways nieuwste vlaggenschip text‑to‑video‑model, bekend om uitstekende fysicasimulatie en beeldstabiliteit, en staat momenteel op #1 in industrie‑benchmarks.',
        faq2Question: 'Wat is het verschil met Gen-4?',
        faq2Answer: 'Gen-4.5 introduceert de A2D‑hybride architectuur. Vergeleken met Gen‑4 biedt het grote verbeteringen in fysiek realisme van beweging (zoals zwaartekracht en inertie), temporele consistentie en begrip van complexe prompts.',
        faq3Question: 'Wat is de videoduur?',
        faq3Answer: 'Gen-4.5 ondersteunt momenteel HD‑clips tot 10 seconden, ideaal voor korte video’s, advertentieshots of film‑previsualisatie (Previs).',
        faq4Question: 'Moet ik betalen om het op 微鲤AI te gebruiken?',
        faq4Answer: '微鲤AI biedt gratis proefcredits voor nieuwe gebruikers. Omdat Gen-4.5 hogere rekenkosten heeft, verbruikt het iets meer credits dan oudere modellen. Upgrade naar Pro wordt aanbevolen voor meer generaties.',
        faq5Question: 'Ondersteunt het “Image to Video”?',
        faq5Answer: 'Ja. De image‑to‑video‑functie van Gen-4.5 is zeer krachtig: het behoudt de stijl en karaktereigenschappen van het referentiebeeld en laat ze natuurlijk bewegen.',
        faq6Question: 'Voor welke projecten is het geschikt?',
        faq6Answer: 'Zeer geschikt voor commercials met filmische kwaliteit, VFX pre-visualisatie, complexe fysische dynamiek (zoals vloeistoffen en explosies) en narratieve korte films.',

        // CTA section
        ctaTitle: 'Ervaar Runway Gen-4.5 nu',
        ctaDescription: 'Probeer Runway Gen-4.5 gratis op 微鲤AI en maak AI-video’s voorbij de verbeelding',
        ctaButton: 'Begin met creëren',
        ctaDisclaimer: 'Geen creditcard nodig · Gratis proefperiode voor nieuwe gebruikers',
        },
    id: {
        // Generator section
        generatorTitle: 'Runway Gen-4.5 AI Video Generator',
        generatorDescription: 'Runway Gen-4.5 adalah model generasi video AI flagship terbaru Runway yang dirilis pada Desember 2025, menandai “batas baru” teknologi video generatif. Sebagai peningkatan besar dari seri Gen‑4, model ini memperkenalkan arsitektur hibrida terobosan Autoregressive-to-Diffusion (A2D) yang menyelesaikan masalah simulasi hukum fisika dan konsistensi temporal jangka panjang pada model sebelumnya. Model ini tidak hanya menempati peringkat #1 di arena video Artificial Analysis dengan skor Elo 1247, tetapi juga menjadi pilihan utama kreator profesional berkat reproduksi presisi dinamika fluida, gravitasi, dan pencahayaan kompleks. Coba Runway Gen-4.5 gratis di 微鲤AI dan rasakan kekuatan kreatif di luar realitas!',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Utama Runway Gen-4.5',
        coreFeaturesSubtitle: 'Selami mesin fisika dan arsitektur hibrida Runway Gen-4.5 untuk kreasi sinematik yang presisi dan terkendali.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Mesin Simulasi Hukum Fisika',
        feature1Description: 'Peningkatan terbesar Gen-4.5 adalah pemahaman mendalam terhadap hukum fisika dunia nyata. Model ini dapat mensimulasikan bobot objek, momentum, tabrakan, dan dinamika fluida kompleks secara akurat, menghilangkan “rasa melayang” serta gerakan kontraintuitif yang umum pada video AI.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Arsitektur Hibrida Autoregressive-to-Diffusion',
        feature2Description: 'Menggabungkan kemampuan pemahaman adegan dari model autoregresif dengan fidelitas visual tinggi dari model difusi. Teknologi hibrida ini memastikan karakter dan objek mempertahankan integritas struktural bahkan saat bergerak cepat atau terhalang, tanpa deformasi atau menghilang.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Kepatuhan Prompt yang Tinggi',
        feature3Description: 'Eksekusi prompt kompleks mencapai level baru, merekonstruksi secara akurat setiap detail yang dideskripsikan pengguna, termasuk komposisi, gaya pencahayaan, dan hubungan interaksi antar subjek, menghasilkan “apa yang Anda pikirkan, itulah yang Anda dapatkan”.',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Konsistensi Temporal Detail Mikro',
        feature4Description: 'Berfokus menjaga stabilitas detail kecil sepanjang waktu. Entah itu rambut yang berayun, riak air, atau tekstur kulit, semuanya tetap koheren sepanjang klip, menghilangkan fenomena “flicker” yang umum pada model tradisional.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan di 微鲤AI',
        step1Title: 'Masuk ke Workspace',
        step1Description: 'Masuk ke workspace kreasi 微鲤AI dan klik pustaka “Video Models” di navigasi kiri.',
        step2Title: 'Pilih Model',
        step2Description: 'Cari dan pilih Runway Gen-4.5 (berlabel New) di daftar model.',
        step3Title: 'Masukkan Deskripsi',
        step3Description: 'Masukkan prompt detail (disarankan mencakup aksi, pencahayaan, dan kondisi fisik) atau unggah gambar referensi untuk memakai fitur “Gambar ke Video”.',
        step4Title: 'Atur Pengaturan dan Buat',
        step4Description: 'Atur rasio aspek (misalnya 16:9) dan durasi (5s atau 10s), lalu klik “Buat sekarang” untuk mendapatkan video HD.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube',

        // X Posts section
        xPostsTitle: 'Posting di X',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Video Lain di 微鲤AI',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: 'Apa itu Runway Gen-4.5?',
        faq1Answer: 'Ini adalah model text-to-video flagship terbaru Runway, dikenal dengan kemampuan simulasi fisika yang sangat baik dan stabilitas gambar, serta saat ini berada di peringkat #1 pada benchmark industri.',
        faq2Question: 'Apa bedanya dengan Gen-4?',
        faq2Answer: 'Gen-4.5 memperkenalkan arsitektur hibrida A2D. Dibanding Gen‑4, ada peningkatan besar pada realisme fisik gerakan objek (seperti gravitasi dan inersia), konsistensi temporal gambar, dan pemahaman prompt kompleks.',
        faq3Question: 'Berapa durasi video?',
        faq3Answer: 'Saat ini, Gen-4.5 mendukung klip HD hingga 10 detik, sangat cocok untuk video pendek, shot iklan, atau pre‑visualization film (Previs).',
        faq4Question: 'Apakah perlu membayar untuk menggunakannya di 微鲤AI?',
        faq4Answer: '微鲤AI menyediakan kredit uji coba gratis untuk pengguna baru. Karena Gen-4.5 memiliki biaya komputasi lebih tinggi, konsumsi kreditnya sedikit lebih banyak dibanding model lama. Disarankan upgrade ke Pro untuk jumlah generasi yang lebih banyak.',
        faq5Question: 'Apakah mendukung "Image to Video"?',
        faq5Answer: 'Ya. Fitur image-to-video Gen-4.5 sangat kuat, mampu mempertahankan gaya dan karakter referensi dengan sempurna serta membuatnya bergerak alami.',
        faq6Question: 'Proyek seperti apa yang cocok?',
        faq6Answer: 'Sangat cocok untuk iklan komersial dengan kualitas sinematik, pre-visualization VFX, tampilan dinamika fisik kompleks (seperti fluida dan ledakan), serta pembuatan film pendek naratif.',

        // CTA section
        ctaTitle: 'Coba Runway Gen-4.5 Sekarang',
        ctaDescription: 'Coba Runway Gen-4.5 gratis di 微鲤AI dan buat video AI melampaui imajinasi',
        ctaButton: 'Mulai Berkarya',
        ctaDisclaimer: 'Tanpa kartu kredit · Uji coba gratis untuk pengguna baru',
        },
    tr: {
        // Generator section
        generatorTitle: 'Runway Gen-4.5 Yapay Zeka Video Üretici',
        generatorDescription: 'Runway Gen-4.5, Runway’in Aralık 2025’te tanıttığı en yeni amiral gemisi AI video üretim modelidir ve üretken video teknolojisinin “yeni sınırını” temsil eder. Gen‑4 serisinin büyük güncellemesi olarak Autoregressive‑to‑Diffusion (A2D) hibrit mimarisini getirir ve önceki modellerin fizik simülasyonu ile uzun süreli zamansal tutarlılık sorunlarını çözer. Artificial Analysis video arenasında Elo 1247 ile #1 olmasının yanı sıra akışkan dinamikleri, yerçekimi ve karmaşık aydınlatmayı hassas biçimde yeniden üretmesi sayesinde profesyonel yaratıcıların bir numaralı tercihi hâline gelmiştir. 微鲤AI’de Runway Gen‑4.5’i ücretsiz deneyin ve gerçekliğin ötesindeki yaratıcı gücü hissedin!',
        
        // Tabs
        tabImageToVideo: 'Görüntüden Videoya',

        // Core features section
        coreFeaturesTitle: 'Runway Gen-4.5 Temel Özellikleri',
        coreFeaturesSubtitle: 'Runway Gen-4.5 video üreticisinin fizik motoru ve hibrit mimarisine derinlemesine dalın; hassas ve kontrollü sinematik üretimi deneyimleyin.',

        // Feature 1: Physics simulation engine
        feature1Title: 'Fizik Simülasyon Motoru',
        feature1Description: 'Gen-4.5’in en büyük iyileştirmesi, gerçek dünya fizik yasalarını derinlemesine anlamasıdır. Nesne ağırlığı, momentum, çarpışmalar ve karmaşık akışkan dinamiklerini doğru şekilde simüle eder; AI videolardaki yaygın “havada süzülme hissini” ve sezgi dışı hareketleri tamamen ortadan kaldırır.',

        // Feature 2: Autoregressive-to-Diffusion hybrid architecture
        feature2Title: 'Autoregressive-to-Diffusion Hibrit Mimarisi',
        feature2Description: 'Otoregresif modellerin sahne anlama kabiliyetini, difüzyon modellerinin yüksek görsel sadakatiyle birleştirir. Bu hibrit teknoloji, hızlı hareket veya örtüşme sırasında bile karakter ve nesnelerin yapısal bütünlüğünü bozmadan korur.',

        // Feature 3: Strong prompt adherence
        feature3Title: 'Güçlü İstem Uyumu',
        feature3Description: 'Modelin karmaşık istemleri uygulaması yeni bir seviyeye ulaşır; kompozisyon, ışık stili ve çoklu özne etkileşimi dahil kullanıcıların tarif ettiği her detayı doğru şekilde geri üretir — “ne düşünüyorsan onu alırsın”.',

        // Feature 4: Micro-detail temporal consistency
        feature4Title: 'Mikro Detaylarda Zamansal Tutarlılık',
        feature4Description: 'Zaman boyunca küçük detayların stabilitesine odaklanır. Saç dalgalanması, su kıpırtıları veya cilt dokusu gibi unsurlar klip boyunca tutarlı kalır ve geleneksel modellerdeki “titreşim” olgusunu ortadan kaldırır.',

        // How to use section
        howToUseTitle: '微鲤AI’de Nasıl Kullanılır',
        step1Title: 'Çalışma Alanına Giriş Yap',
        step1Description: '微鲤AI çalışma alanına girin ve sol gezinme çubuğundaki “Video Models” kütüphanesine tıklayın.',
        step2Title: 'Modeli Seç',
        step2Description: 'Model listesinde Runway Gen-4.5’i (New etiketiyle) bulun ve seçin.',
        step3Title: 'Açıklama Girin',
        step3Description: 'Metin kutusuna ayrıntılı isteminizi girin (aksiyon, ışık ve fiziksel durum açıklamaları önerilir) veya “Görüntüden Videoya” için referans görsel yükleyin.',
        step4Title: 'Ayarları Yapın ve Üretin',
        step4Description: 'En‑boy oranını (ör. 16:9) ve süreyi (5s veya 10s) ayarlayın, ardından “Şimdi oluştur”a tıklayarak HD video elde edin.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videoları',

        // X Posts section
        xPostsTitle: 'X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: '微鲤AI’de Diğer Video Modellerini Keşfedin',
        modelVeo31: 'Veo 3.1',
        modelSeedance: 'Seedance',
        modelWanAI: 'Wan AI',
        modelSora2: 'Sora 2',

        // FAQ section
        faqTitle: 'Sık Sorulan Sorular',
        faq1Question: 'Runway Gen-4.5 nedir?',
        faq1Answer: 'Runway’in en yeni amiral gemisi text‑to‑video modelidir; güçlü fizik simülasyonu ve görüntü stabilitesiyle bilinir ve şu anda sektör benchmark testlerinde birinci sıradadır.',
        faq2Question: 'Gen-4 ile arasındaki fark nedir?',
        faq2Answer: 'Gen-4.5, A2D hibrit mimarisini getirir. Gen‑4’e kıyasla, nesne hareketinin fiziksel gerçekçiliği (yerçekimi ve atalet gibi), görüntülerin zamansal tutarlılığı ve karmaşık istemleri anlama açısından büyük iyileştirmeler sunar.',
        faq3Question: 'Video süresi ne kadar?',
        faq3Answer: 'Gen-4.5 şu anda 10 saniyeye kadar HD klipleri destekler; kısa videolar, reklam çekimleri veya film ön görselleştirmesi (Previs) için idealdir.',
        faq4Question: '微鲤AI’de kullanmak için ödeme gerekir mi?',
        faq4Answer: '微鲤AI yeni kullanıcılar için ücretsiz deneme kredileri sunar. Gen-4.5’in hesaplama maliyeti daha yüksek olduğu için eski modellere göre biraz daha fazla kredi tüketir. Daha fazla üretim için Pro üyeliğe yükseltme önerilir.',
        faq5Question: '“Image to Video” destekliyor mu?',
        faq5Answer: 'Evet. Gen-4.5’in image‑to‑video özelliği çok güçlüdür; referans görselin stilini ve karakter özelliklerini mükemmel şekilde korur ve doğal hareket ettirir.',
        faq6Question: 'Hangi proje türleri için uygundur?',
        faq6Answer: 'Sinematik kalite hedefleyen reklamlar, VFX ön görselleştirme, karmaşık fizik dinamikleri (sıvılar ve patlamalar gibi) ve anlatı odaklı kısa film üretimleri için çok uygundur.',

        // CTA section
        ctaTitle: 'Runway Gen-4.5’i Şimdi Deneyin',
        ctaDescription: '微鲤AI’de Runway Gen-4.5’i ücretsiz deneyin ve hayal gücünün ötesinde AI videolar oluşturun',
        ctaButton: 'Oluşturmaya Başla',
        ctaDisclaimer: 'Kredi kartı gerekmez · Yeni kullanıcılar için ücretsiz deneme',
        },
}
